<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style scoped>
.vue-form-wizard .wizard-tab-content {
  padding: 0px 20px 10px !important;
}
.tab-customize .vs-tabs--content {
  padding: 0;
  margin-top: 30px;
}
.CustomBrandingOptions {
  background: #d7d7d7;
}
.CustomBrandingOptions .preview-screens {
  width: 100%;
}
.CustomBrandingOptions .theme-selection {
  width: 100%;
  padding: 20px;
}
.theme-selection h4 {
  color: #252d39;
}
.theme-selection p {
  color: #252d39;
}
.image-preview-wrap .img-preview {
  width: calc(50% - 10px);
}
.image-preview-wrap .img-preview img {
  width: 100%;
}
</style>
<style scoped src="@/assets/css/screen.css"></style>
<style>
.tab-customize .con-ul-tabs {
  border-bottom: 1px solid #ddd !important;
}
.theme-selection .vs-radio {
  display: none;
}
.theme-selection .vs-radio--label {
  border: 3px solid #fff;
  border-radius: 35px;
  min-width: 102px;
  text-align: center;
  padding: 10px;
  display: inline-block;
  color: #fff;
  font-weight: 500;
  margin: 0;
}
.theme-selection .light-theme .vs-radio--label {
  background: #fff;
  color: #000;
}
.theme-selection .dark-theme .vs-radio--label {
  background: #000;
  color: #fff;
}
.theme-selection .custom-theme .vs-radio--label {
  background: linear-gradient(
    90deg,
    rgba(255, 0, 0, 1) 0%,
    rgba(255, 154, 0, 1) 10%,
    rgba(208, 222, 33, 1) 20%,
    rgba(79, 220, 74, 1) 30%,
    rgba(63, 218, 216, 1) 40%,
    rgba(47, 201, 226, 1) 50%,
    rgba(28, 127, 238, 1) 60%,
    rgba(95, 21, 242, 1) 70%,
    rgba(186, 12, 248, 1) 80%,
    rgba(251, 7, 217, 1) 90%,
    rgba(255, 0, 0, 1) 100%
  );
  color: #fff;
}
.theme-selection input[type="radio"]:checked + span + span {
  border-color: #007bff;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
}
.preview-screens {
  padding: 20px;
}
.preview-screens .live-preview-simulator {
  width: 25%;
  padding: 0 10px;
}
.preview-screens .live-preview-simulator .simulator-wrap {
  height: 700px;
  margin-bottom: 20px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
}
.simulator-wrap figure {
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  pointer-events: none;
}
.simulator-wrap figure img {
  width: 100%;
  height: 100%;
}
.preview-content {
  height: 100%;
  overflow: hidden;
  border-radius: 54px;
  padding: 22px;
  /* background-image: url(../../assets/branding-background-image.png); */
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.simulator-navigation {
  padding: 25px 15px 0px 15px;
  width: 100%;
}
.simulator-navigation.justify-content-between {
  justify-content: space-between !important;
}
.simulator-navigation a {
  display: inline-block;
  position: relative;
}
.sim-page-title {
  display: inline-block;
  font-weight: 500;
  margin-top: 2px;
  margin-left: 10px;
  font-size: 18px;
}
ul.sim-sidebar-menu li {
  margin-bottom: 15px;
}
.sim-welcome-text {
  padding: 20px 10px;
  text-align: center;
}
.sim-welcome-text h3 {
  font-size: 18px;
}
.sim-welcome-text h4 {
  font-size: 20px;
  font-weight: 600;
}
.sim-lobby-cont {
  padding: 0 15px;
}
.sim-lobby-cont > .d-flex {
  margin: 0 -5px;
}
.sim-lobby-cont .sim-icon-card-wrap {
  width: calc(100% / 3);
  padding: 0 5px;
  text-align: center;
  margin-bottom: 15px;
}
.sim-icon-card-wrap .sim-icon-card {
  height: 86px;
  border-radius: 7px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  margin-bottom: 5px;
  position: relative;
}
.sim-icon-card-wrap .sim-icon-card .color-picker-label {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.sim-card-title {
  font-size: 15px;
  font-weight: 500;
}
.notification-holder {
  position: relative;
  padding-right: 5px;
  margin-top: 5px;
}
.notification-holder i {
  position: absolute;
  height: 20px;
  width: 20px;
  background: #ff3924;
  color: #fff;
  border-radius: 100%;
  font-style: normal;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  right: -5px;
  top: -7px;
}
.sim-attendee-listing-view {
  position: relative;
  z-index: 1;
}
.sim-search {
  padding: 10px;
}
.sim-search input {
  width: 100%;
  height: 30px;
  box-shadow: none;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0 10px 0 30px;
  background: #fff url("../../assets/images/search.svg") no-repeat 10px center;
  background-size: 15px !important;
  font-size: 12px;
}
.sim-attendee-list {
  padding: 10px;
  height: 500px;
  overflow: auto;
}
/* width */
.sim-attendee-list::-webkit-scrollbar {
  width: 4px;
  position: absolute;
}

/* Track */
.sim-attendee-list::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
.sim-attendee-list::-webkit-scrollbar-thumb {
  background: #888;
}
.sim-attendee-card {
  border-radius: 6px;
  overflow: hidden;
  padding: 10px;
  margin-bottom: 10px;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.3);
}
.sim-attendee-card:last-child {
  margin: 0;
}
.sim-attendee-card .sim-attendee-image {
  width: 70px;
  height: 70px;
  border-radius: 100%;
  position: relative;
}
.sim-attendee-name-details {
  width: calc(100% - 70px);
  padding-left: 10px;
}
.sim-attendee-name-details h5 {
  font-size: 18px;
  margin-bottom: 4px;
}
.sim-attendee-name-details p {
  font-size: 13px;
}
.sim-attendee-name-details .texts {
  width: calc(100% - 24px);
}
.sim-bottom-navigation {
  position: absolute;
  bottom: 22px;
  left: 17px;
  width: calc(100% - 33px);
  height: 45px;
  border-radius: 0 0 15px 15px;
  z-index: 2;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
}
.sim-bottom-navigation-item {
  width: calc(100% / 4);
  padding: 5px;
  text-align: center;
}
.sim-bottom-navigation-item span {
  display: inline-block;
  /* height: 20px;
  width: 20px; */
}
.sim-bottom-navigation-item p {
  font-size: 10px;
  font-weight: 500;
  margin-top: -5px;
}
.sim-attendee-details {
  margin-top: 50px;
  border-radius: 10px 10px 0 0;
  position: relative;
  padding: 40px 15px 15px 15px;
  text-align: center;
}
.sim-attendee-details .sim-attendee-d-image {
  height: 80px;
  width: 80px;
  border-radius: 100%;
  font-size: 20px;
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
}
.sim-attendee-details h5 {
  font-size: 22px;
  font-weight: 500;
  margin-top: 5px;
}
.sim-attendee-details p {
  font-size: 13px;
}
.sim-attendee-desc {
  padding-top: 10px;
  width: calc(100% + 30px);
  margin-left: -15px;
}
.sim-desc-tabs {
  margin-bottom: 10px;
  padding: 0 15px;
}
.sim-desc-tabs a {
  font-size: 14px;
  display: inline-block;
  padding: 7px 10px;
  position: relative;
}
.sim-desc-tabs a span {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 40px;
  height: 2px;
}
.sim-tab-cont {
  padding: 0 15px;
  min-height: 131px;
}
.sim-attendee-desc p {
  text-align: left;
  font-size: 14px;
}
.sim-buttons a {
  display: flex;
  flex-wrap: wrap;
  width: 200px;
  height: 45px;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 15px;
  font-weight: 500;
}
.sim-buttons a svg {
  margin-right: 5px;
}
.sim-attendee-card .sim-sponsors-logo {
  width: 60px;
  height: 60px;
}
.sim-attendee-card .sim-sponsors-logo img {
  width: 100%;
  height: auto;
}
.sim-bookmark-holder {
  height: 24px;
}
.sim-attendee-name-details .texts span {
  display: inline-block;
  margin-top: 10px;
  border-radius: 35px;
  padding: 0 15px;
  font-size: 12px;
  font-weight: 500;
}
.sm-exhibits-details {
  margin-top: 20px;
  border-radius: 6px 6px 0 0;
  padding: 10px;
}
.sm-exhibits-details .sim-sp-logo {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.sm-exhibits-details .sim-sp-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.sim-sponsor-text {
  width: calc(100% - 60px);
  padding-left: 10px;
}
.sim-sponsor-text .left-text h5 {
  font-size: 18px;
}
.sim-sponsor-text .left-text span {
  margin-top: 10px;
  border-radius: 35px;
  padding: 0 15px;
  display: inline-block;
  font-size: 12px;
}
.sim-sponsor-text .left-text {
  width: calc(100% - 24px);
}
.sim-sponsor-text a {
  width: 24px;
}
.sp-logo-link {
  justify-content: space-between;
  margin-top: 10px;
}
.sp-logo-link .sp-logo-link-holder {
  width: calc(50% - 3px);
}
.sp-logo-link a {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 4px;
  padding: 5px;
}
.sp-logo-link a span.sim-icon {
  width: 20px;
  height: 20px;
}
.sp-logo-link a span.sim-icon svg {
  width: 100%;
  height: 100%;
}
.sp-logo-link a span.sim-btn-text {
  width: calc(100% - 20px);
  padding-left: 7px;
  font-size: 14px;
  line-height: 18px;
}
.sim-wrapper {
  overflow: hidden;
  height: 656px;
  /* background-color: rgba(0,0,0,0.6); */
}
.sim-wrapper.sidebar-open:after {
  content: "";
  position: absolute;
  top: 22px;
  left: 22px;
  background: rgba(0, 0, 0, 0.3);
  height: calc(100% - 44px);
  width: calc(100% - 44px);
}
.sim-wrapper .sim-sidebar {
  position: absolute;
  top: 22px;
  left: 22px;
  width: 250px;
  height: calc(100% - 32px);
  padding-top: 25px;
  z-index: 9;
}
.vs-button.sim-close-sidebar {
  padding: 0 !important;
  border-radius: 0;
  height: 24px;
  width: 24px;
}
.vs-button.sim-close-sidebar .vs-button-text {
  height: 24px !important;
}
.sim-sidebar-top {
  padding-right: 5px;
  padding-bottom: 5px;
}
.sim-sidebar-top .sim-switch-event {
  font-size: 12px;
}
.sim-logged-user {
  height: 35px;
  width: 35px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
.sim-sidebar-menu li a {
  padding: 6px 10px;
}
.sim-sidebar-menu li a .s-menu-icon {
  height: 16px;
  margin-right: 7px;
}
.custom-color-picker h5 {
  color: #fff;
  border-bottom: 1px solid #fff;
  font-size: 18px;
  padding-bottom: 10px;
  margin-bottom: 30px;
}
.custom-color-picker ul {
  background: #fff;
  padding: 10px;
}
.custom-color-picker ul li {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #000;
  align-items: center;
  padding: 7px;
}
.custom-color-picker ul li:not(:last-child) {
  border-bottom: none;
}
.custom-color-picker ul li span.input-text {
  display: flex;
  color: #000;
  font-weight: 600;
  width: calc(100% - 70px);
  padding-right: 15px;
  align-items: center;
}

.custom-color-picker ul li input {
  width: 70px;
}
.color-info {
  background: transparent !important;
  padding: 0 !important;
  height: 29px;
  width: 29px;
  border-radius: 100%;
}
.color-info .vs-button--text {
  padding: 0;
}
.con-vs-tooltip {
  display: inline-block;
}
.color-picker-label input {
  position: absolute;
  visibility: hidden;
}
.color-picker-label {
  display: flex;
  position: absolute;
  height: 30px;
  width: 30px;
  background: #eb775d;
  opacity: 0.5;
  border-radius: 100%;
  -webkit-animation: ripple 0.7s linear infinite;
  animation: ripple 0.7s linear infinite;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
}
.color-picker-label img {
  height: 28px;
}
.sim-sidebar .color-picker-label {
  bottom: 50px;
  right: 20px;
}
@-webkit-keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(235, 119, 93, 0.3),
      0 0 0 10px rgba(235, 119, 93, 0.3), 0 0 0 20px rgba(235, 119, 93, 0.3);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(235, 119, 93, 0.3),
      0 0 0 20px rgba(235, 119, 93, 0.3), 0 0 0 30px rgba(235, 119, 93, 0);
  }
}

@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgba(235, 119, 93, 0.3),
      0 0 0 10px rgba(235, 119, 93, 0.3), 0 0 0 20px rgba(235, 119, 93, 0.3);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(235, 119, 93, 0.3),
      0 0 0 20px rgba(235, 119, 93, 0.3), 0 0 0 30px rgba(235, 119, 93, 0);
  }
}
.color-picker-label:hover {
  opacity: 1;
}
.simulator-navigation {
  position: relative;
}
.simulator-navigation .color-picker-label {
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
}
.sim-page-title .color-picker-label {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.texts .color-picker-label {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.sim-attendee-details .color-picker-label {
  top: 0;
  right: 0;
}
.sim-desc-tabs .color-picker-label {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
.sp-logo-link-holder .color-picker-label {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.sim-tab-link-holder .color-picker-label {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.sim-bookmark-holder .color-picker-label {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.theme-selection-wrapper {
  margin-top: 20px;
}
.theme-selection-wrapper .radio-holder:not(:last-child) {
  margin-right: 15px;
}
.sim-attendee-image,
.color-picker-label.change-attendee-imagebox-color {
  transition: all 1s;
}
.attendee-branding-image-color:has(.color-picker-label.change-attendee-imagebox-color:hover) {
  transition: all 1s;
  box-shadow: 0 0 0 5px #eb775d;
}
label.color-picker-label.change-attendee-imagebox-color img {
  height: 16px;
  width: 16px;
}
label.color-picker-label.change-attendee-imagebox-color {
  right: 0px;
  bottom: 4px;
  cursor: pointer;
}
.sim-attendee-details,
.attendee-details-color-change {
  transition: all 1s;
}
.sim-attendee-details:has(.attendee-details-color-change:hover) {
  box-shadow: 0 0 0 5px #eb775d;
  transition: all 1s;
}
.sim-page-title,
.headers-color-changes {
  transition: all 1s;
}
.sim-page-title:has(.headers-color-changes:hover) {
  text-shadow: 0px 0px 8px #f00, 0 0 05px green, 0px 0 4px yellow;
  transition: all 1s;
}
.sim-sidebar,
.sidebar-changes-color {
  transition: all 1s;
}
.sim-sidebar:has(.sidebar-changes-color:hover) {
  box-shadow: 0 0 0 5px #eb775d;
  transition: all 1s;
}
.simulator-navigation,
.change-nav-color {
  transition: all 1s;
}
.simulator-navigation:has(.change-nav-color:hover) {
  box-shadow: 0 0 0 5px #eb775d;
  transition: all 1s;
}
.exchange-button-color-change,
#exchangebuttonchange {
  transition: all 1s !important;
}
.exchange-button-color-change:hover + #exchangebuttonchange {
  box-shadow: 0 0 0 5px #eb775d !important;
  transition: all 1s;
}
.roundtable-button-colorchange,
#joinRoundTableColorChanger {
  transition: all 1s !important;
}
.roundtable-button-colorchange:hover + #joinRoundTableColorChanger {
  box-shadow: 0 0 0 5px #eb775d !important;
  transition: all 1s !important;
}
@media only screen and (min-width: 1500px) and (max-width: 1699px) {
  .preview-screens .live-preview-simulator {
    width: 33.33%;
  }
}
@media only screen and (min-width: 1401px) and (max-width: 1499px) {
  .preview-screens .live-preview-simulator {
    width: 33.33%;
  }
}
@media (max-width: 1400px) {
  .preview-screens .live-preview-simulator {
    width: 40%;
  }
}
</style>
<template>
  <div class="event-edit-wrapper" v-if="BrandingJson">
    <div class>
      <div class="header-custome">
        <h3>Event Custom Branding</h3>
      </div>
    </div>

    <vx-card title title-color subtitle>
      <div class="vx-col md:w-1/1 w-full">
        <vs-tabs class="tab-customize" v-model="currentTab">
          <vs-tab label="Color Scheme" @click="showSubmitButton = true">
            <div class="tab-text">
              <div class="d-flex flex-wrap CustomBrandingOptions">
                <div class="theme-selection">
                  <h4 class="mb-3">Color Scheme</h4>
                  <div class="flex justify-between items-center">
                    <p>
                      Choose a theme color from the available combinations in
                      the drop down. If you do not choose a theme color, default
                      color theme will be applied.
                    </p>
                    <div class="second-branding-tab">
                      <ul class="flex justify-end items-center">
                        <li>
                          <vs-radio v-model="viewMobile" vs-value="Desktop"
                            ><feather-icon icon="MonitorIcon" />
                            Desktop</vs-radio
                          >
                        </li>
                        <li>
                          <vs-radio v-model="viewMobile" vs-value="Mobile"
                            ><feather-icon icon="SmartphoneIcon" />
                            Mobile</vs-radio
                          >
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    class="theme-selection-wrapper d-flex flex-wrap"
                    :style="
                      viewMobile == 'Desktop' ? 'display: none !important' : ''
                    "
                  >
                    <div class="radio-holder">
                      <vs-radio
                        class="light-theme"
                        v-model="BrandingJson.appColorHexCodeType"
                        vs-value="headerColorsHexCodeLight"
                        @input="setheaderColorsHexCode('Light')"
                        >Light</vs-radio
                      >
                    </div>
                    <div class="radio-holder">
                      <vs-radio
                        class="dark-theme"
                        v-model="BrandingJson.appColorHexCodeType"
                        vs-value="headerColorsHexCodeDark"
                        @input="setheaderColorsHexCode('Dark')"
                        >Dark</vs-radio
                      >
                    </div>

                    <div class="radio-holder">
                      <vs-radio
                        class="custom-theme"
                        v-model="BrandingJson.appColorHexCodeType"
                        vs-value="headerColorsHexCodeCustom"
                        @input="setheaderColorsHexCode('Custom')"
                        >Custom</vs-radio
                      >
                    </div>
                  </div>

                  <div
                    class="theme-selection-wrapper d-flex flex-wrap"
                    :style="
                      viewMobile == 'Mobile' ? 'display: none !important' : ''
                    "
                  >
                    <div class="radio-holder">
                      <vs-radio
                        class="light-theme"
                        v-model="BrandingJson.webColorHexCodeType"
                        vs-value="webheaderColorsHexCodeLight"
                        @input="setheaderColorsHexCode('Light')"
                        >Light</vs-radio
                      >
                    </div>
                    <div class="radio-holder">
                      <vs-radio
                        class="dark-theme"
                        v-model="BrandingJson.webColorHexCodeType"
                        vs-value="webheaderColorsHexCodeDark"
                        @input="setheaderColorsHexCode('Dark')"
                        >Dark</vs-radio
                      >
                    </div>


                    <!-- <div class="radio-holder" >
                      <vs-radio
                        class="custom-theme"
                        v-model="BrandingJson.webColorHexCodeType"
                        vs-value="headerColorsHexCodeCustom"
                        @input="setheaderColorsHexCode('Custom')"
                        >Custom</vs-radio
                      >
                    </div> -->
                  </div>
                </div>
                <div
                  v-if="viewMobile == 'Desktop'"
                  class="desktop-preview-screens d-block"
                >
                  <div class="live-preview-desktop">
                    <div class="desktop-simulator-screen">
                      <figure>
                        <img src="../../assets/images/desktop-simulator.png" />
                      </figure>
                      <div class="simulator-attendee-wrap">
                        <div
                          class="simualtor-desktop-header-banner"
                          v-if="desktopBanner"
                        >
                          <img :src="desktopBanner" />
                        </div>
                        <div class="simualtor-desktop-header-banner" v-else>
                          <img
                            src="https://resources.e2m.live/e2monair.appspot.com/OA_UAT_C1594888724987E1611070965720%2FBranding%2F2048x88_1639633611233.png?alt=media&token=4b736736-d04d-4634-8aca-81c0124d4dcb"
                          />
                        </div>

                        <div
                          :class="
                            topBarColor
                              ? 'simulator-desktop-nav-wrap position-relative'
                              : 'simulator-desktop-nav-wrap position-relative'
                          "
                          :style="
                            topBarColor
                              ? 'background-color:' + topBarColor + '!important'
                              : ''
                          "
                        >
                          <!-- <label
                            class="
                              color-picker-label
                              sidebar-changes-color
                              desktop-color-picker
                              d-none
                            "
                          >
                            <img
                              src="../../assets/images/color-picker.svg"
                              style="height: 16px; width: 16px"
                            />
                            <input id="" type="color" />
                          </label> -->

                          <div class="blank-wrap">&nbsp;</div>
                          <div class="simulator-desktop-nav-menu">
                            <ul>
                              <li
                                v-for="topMenu in SelectedWebTopMenu"
                                :key="topMenu.MenuID"
                                :style="'color:' + fontBarColor"
                              >
                                <span class="mr-2">
                                  <span
                                    v-for="icons in defaultSvgs.appIconSet"
                                    :key="icons.Name"
                                  >
                                    <svg
                                      v-if="icons.Name == topMenu.Name"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="18px"
                                      height="18px"
                                      viewBox="0 0 83.812 69"
                                    >
                                      <path
                                        id="dynamic.svg"
                                        class="cls-1"
                                        :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                        :d="icons.svgd"
                                        :transform="icons.svgTransform"
                                      />
                                    </svg>
                                  </span>
                                </span>
                                {{ topMenu.DisplayLabel }}
                              </li>
                            </ul>
                          </div>

                          <div class="simulator-desktop-nav-wrap-right">
                            <div class="sim-logged-user">
                              <p>{{
                                loggedInUserName
                                  .split(" ")
                                  .map((n) => n[0])
                                  .join("")
                              }}</p>
                            </div>
                            <h5 :style="'color:' + fontBarColor">
                              {{ loggedInUserName }}
                              <span class="ml-2"
                                ><feather-icon icon="ChevronDownIcon"
                              /></span>
                            </h5>
                          </div>
                        </div>
                        <div class="simulator-desktop-section-inner">
                          <div
                            class="simulator-inner-wrap"
                            :style="
                              desktopBackground
                                ? 'background:' +
                                  'url(' +
                                  desktopBackground +
                                  ') no-repeat center center / cover' +
                                  '!important'
                                : ''
                            "
                          >
                            <div class="simulator-section-header">
                              <h5>Attendees</h5>
                              <div class="simulator-search-section">
                                <input
                                  type="text"
                                  value=""
                                  placeholder="Search by Name, Company, Title, Keywords and Clcik on Go"
                                />
                                <div class="search-button">
                                  <feather-icon icon="SearchIcon" />
                                </div>
                              </div>
                            </div>

                            <div class="inner-section-of-simulator">
                              <div
                                class="left-side-menu"
                                :style="
                                  topBarColor
                                    ? 'background-color:' +
                                      topBarColor +
                                      '!important'
                                    : ''
                                "
                              >
                                <ul>
                                  <li
                                    v-for="leftMenu in SelectedWebLeftMenu"
                                    :key="leftMenu.MenuID"
                                    :style="'color:' + fontBarColor"
                                  >
                                    <span class="mr-2">
                                      <span
                                        v-for="icons in defaultSvgs.appIconSet"
                                        :key="icons.Name"
                                      >
                                        <svg
                                          v-if="icons.Name == leftMenu.Name"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18px"
                                          height="18px"
                                          viewBox="0 0 83.812 69"
                                        >
                                          <path
                                            id="dynamic.svg"
                                            class="cls-1"
                                            :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                            :d="icons.svgd"
                                            :transform="icons.svgTransform"
                                          />
                                        </svg>
                                      </span>
                                    </span>
                                    <p>{{ leftMenu.DisplayLabel }}</p>
                                  </li>
                                </ul>
                              </div>
                              <div class="vx-row">
                                <div
                                  class="vx-col md:w-4/12 w-full"
                                  v-for="(attendee, index) in allAttendees"
                                  :key="attendee.AttendeeId"
                                >
                                  <div class="single-attendee">
                                    <div class="attendee-image">
                                      <!-- <img
                                        src="../../assets/images/default_avatar.jpg"
                                      /> -->
                                      <h3>{{
                                        attendee.Name.split(" ")
                                          .map((n) => n[0])
                                          .join("")
                                      }}</h3>
                                    </div>
                                    <div
                                      class="attendee-details position-relative"
                                    >
                                      <!-- <label
                                        v-if="index == 0"
                                        class="
                                          color-picker-label
                                          sidebar-changes-color
                                          desktop-txt-color-picker
                                          d-none
                                        "


                                      >
                                        <img
                                          src="../../assets/images/color-picker.svg"
                                          style="height: 16px; width: 16px"
                                        />
                                        <input id="" type="color" />
                                      </label> -->
                                      <h4>{{ attendee.Name }}</h4>
                                      <p>{{ attendee.Company }}</p>
                                      <p>{{ attendee.Designation }}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="viewMobile == 'Mobile'"
                  class="preview-screens d-flex flex-wrap justify-center"
                >
                  <div class="live-preview-simulator">
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' +
                          virtuallobby_data.coundownLobby.bgImageApp +
                          ')'
                        "
                      >
                        <div class="sim-wrapper sidebar-open">
                          <div
                            class="simulator-navigation d-flex align-center"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `background:${BrandingJson['headerColorsHexCodeCustom']['topBar']}`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `background:${BrandingJson['headerColorsHexCodeLight']['topBar']}`
                                : `background:${BrandingJson['headerColorsHexCodeDark']['topBar']}`
                            "
                          >
                            <a href="#">
                              <svg
                                :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="30px"
                                height="30px"
                              >
                                <path
                                  d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                                />
                              </svg>
                            </a>
                            <span
                              class="sim-page-title"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `color:${BrandingJson['headerColorsHexCodeCustom']['sideNavigationAndIconColor']}`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `color:${BrandingJson['headerColorsHexCodeLight']['sideNavigationAndIconColor']}`
                                  : `color:${BrandingJson['headerColorsHexCodeDark']['sideNavigationAndIconColor']}`
                              "
                              >Lobby</span
                            >
                          </div>
                          <div
                            class="sim-sidebar"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']}`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']}`
                                : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']}`
                            "
                          >
                            <label
                              v-show="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                              "
                              @mouseenter="lobbycardcolorchanger"
                              @mouseleave="lobbycardcolorcdefault"
                              for="variable1"
                              class="color-picker-label sidebar-changes-color"
                            >
                              <img
                                src="../../assets/images/color-picker.svg"
                                style="height: 16px; width: 16px"
                              />
                              <input
                                id="variable1"
                                :disabled="
                                  BrandingJson.appColorHexCodeType !=
                                  'headerColorsHexCodeCustom'
                                "
                                v-model="
                                  BrandingJson['headerColorsHexCodeCustom'][
                                    'navigationBackgroundColor'
                                  ]
                                "
                                type="color"
                              />
                            </label>
                            <div
                              class="
                                sim-sidebar-top
                                d-flex
                                flex-wrap
                                justify-between
                                align-items-center
                              "
                              style="border-bottom: 1px solid #ddd"
                            >
                              <vs-button
                                class="sim-close-sidebar"
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `background:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']} !important`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `background:${BrandingJson['headerColorsHexCodeLight']['iconBackground']} !important`
                                    : `background:${BrandingJson['headerColorsHexCodeDark']['iconBackground']} !important`
                                "
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `fill:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']}`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `fill:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']}`
                                      : `fill:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']}`
                                  "
                                >
                                  <path
                                    d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z"
                                  ></path>
                                </svg>
                              </vs-button>
                              <span
                                class="sim-switch-event"
                                :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                              >
                                Switch Events
                              </span>
                              <div
                                class="sim-logged-user"
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']}`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeLight']['iconBackground']}`
                                    : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeDark']['iconBackground']}`
                                "
                              >
                                {{
                                  loggedInUserName
                                    .split(" ")
                                    .map((n) => n[0])
                                    .join("")
                                }}
                              </div>
                            </div>
                            <ul class="sim-sidebar-menu">
                              <li>
                                <a
                                  href="#"
                                  class="d-flex flex-wrap align-items-center"
                                >
                                  <span class="s-menu-icon">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20px"
                                      height="16"
                                      viewBox="0 0 83.812 69"
                                    >
                                      <path
                                        id="my-profile.svg"
                                        class="cls-1"
                                        :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                        d="M854,187a36,36,0,1,1,36-36A36,36,0,0,1,854,187Zm0-5.55a30.288,30.288,0,0,0,18.827-6.549c-2-7.345-9.661-12.822-18.827-12.822s-16.825,5.478-18.825,12.824A30.289,30.289,0,0,0,854,181.448Zm8.307-33.216A8.308,8.308,0,1,0,854,156.539,8.307,8.307,0,0,0,862.306,148.232ZM854,120.554a30.425,30.425,0,0,0-23.159,50.183,23.534,23.534,0,0,1,13.618-12.509,13.845,13.845,0,1,1,19.082,0,23.552,23.552,0,0,1,13.621,12.506A30.426,30.426,0,0,0,854,120.554Z"
                                        transform="translate(-818 -115)"
                                      />
                                    </svg>
                                  </span>
                                  <span
                                    :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    class="s-menu-text"
                                    >My Profile</span
                                  >
                                </a>
                              </li>
                              <li
                                v-for="hamburgerMenu in SelectedHamburgerMenu"
                                :key="hamburgerMenu.MenuID"
                              >
                                <a
                                  href="#"
                                  class="d-flex flex-wrap align-items-center"
                                >
                                  <span
                                    v-for="icons in defaultSvgs.appIconSet"
                                    :key="icons.Name"
                                  >
                                    <span
                                      v-if="icons.Name == hamburgerMenu.Name"
                                      class="s-menu-icon"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20px"
                                        height="16"
                                        viewBox="0 0 83.812 69"
                                      >
                                        <path
                                          id="dynamic.svg"
                                          class="cls-1"
                                          :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                          :d="icons.svgd"
                                          :transform="icons.svgTransform"
                                        />
                                      </svg>
                                    </span>
                                  </span>

                                  <span
                                    :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    class="s-menu-text"
                                    >{{ hamburgerMenu.DisplayLabel }}</span
                                  >
                                </a>
                              </li>
                            </ul>
                          </div>
                          <div class="sim-welcome-text">
                            <h3>Welcome {{ loggedInUserName }}</h3>
                            <h4>{{ currentEventName }}</h4>
                          </div>
                          <div class="sim-lobby-cont">
                            <div class="d-flex flex-wrap">
                              <div class="sim-icon-card-wrap">
                                <div
                                  class="
                                    sim-icon-card
                                    d-flex
                                    align-items-center
                                    justify-center
                                  "
                                  :style="`background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 32 32"
                                  >
                                    <path
                                      :style="`fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']}`"
                                      id="round-table.svg"
                                      class="cls-1"
                                      d="M1415.27,1402.2l-1.49-1.5a13.949,13.949,0,0,0,0-11.41l1.49-1.49A15.848,15.848,0,0,1,1415.27,1402.2ZM1401,1405a10,10,0,1,1,10-10A10,10,0,0,1,1401,1405Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,1401,1387Zm0-6a13.953,13.953,0,0,0-5.71,1.22l-1.49-1.5a15.93,15.93,0,0,1,14.4,0l-1.49,1.5A13.988,13.988,0,0,0,1401,1381Zm-14.27,21.2a15.848,15.848,0,0,1,0-14.4l1.49,1.49a13.949,13.949,0,0,0,0,11.41ZM1401,1409a13.913,13.913,0,0,0,5.7-1.23l1.5,1.5a15.848,15.848,0,0,1-14.4,0l1.5-1.5A13.913,13.913,0,0,0,1401,1409Z"
                                      transform="translate(-1385 -1379)"
                                    />
                                  </svg>
                                </div>
                                <span
                                  class="sim-card-title"
                                  :style="`color:${BrandingJson['headerColorsHexCodeCustom']['inactiveButtonColor']}`"
                                  >Session</span
                                >
                              </div>
                              <div class="sim-icon-card-wrap">
                                <div
                                  class="
                                    sim-icon-card
                                    d-flex
                                    align-items-center
                                    justify-center
                                  "
                                  :style="`background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 32 32"
                                  >
                                    <path
                                      :style="`fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']}`"
                                      id="round-table.svg"
                                      class="cls-1"
                                      d="M1415.27,1402.2l-1.49-1.5a13.949,13.949,0,0,0,0-11.41l1.49-1.49A15.848,15.848,0,0,1,1415.27,1402.2ZM1401,1405a10,10,0,1,1,10-10A10,10,0,0,1,1401,1405Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,1401,1387Zm0-6a13.953,13.953,0,0,0-5.71,1.22l-1.49-1.5a15.93,15.93,0,0,1,14.4,0l-1.49,1.5A13.988,13.988,0,0,0,1401,1381Zm-14.27,21.2a15.848,15.848,0,0,1,0-14.4l1.49,1.49a13.949,13.949,0,0,0,0,11.41ZM1401,1409a13.913,13.913,0,0,0,5.7-1.23l1.5,1.5a15.848,15.848,0,0,1-14.4,0l1.5-1.5A13.913,13.913,0,0,0,1401,1409Z"
                                      transform="translate(-1385 -1379)"
                                    />
                                  </svg>
                                </div>
                                <span
                                  class="sim-card-title"
                                  :style="`color:${BrandingJson['headerColorsHexCodeCustom']['inactiveButtonColor']}`"
                                  >Session</span
                                >
                              </div>
                              <div class="sim-icon-card-wrap">
                                <div
                                  class="
                                    sim-icon-card
                                    d-flex
                                    align-items-center
                                    justify-center
                                  "
                                  :style="`background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 32 32"
                                  >
                                    <path
                                      :style="`fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']}`"
                                      id="round-table.svg"
                                      class="cls-1"
                                      d="M1415.27,1402.2l-1.49-1.5a13.949,13.949,0,0,0,0-11.41l1.49-1.49A15.848,15.848,0,0,1,1415.27,1402.2ZM1401,1405a10,10,0,1,1,10-10A10,10,0,0,1,1401,1405Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,1401,1387Zm0-6a13.953,13.953,0,0,0-5.71,1.22l-1.49-1.5a15.93,15.93,0,0,1,14.4,0l-1.49,1.5A13.988,13.988,0,0,0,1401,1381Zm-14.27,21.2a15.848,15.848,0,0,1,0-14.4l1.49,1.49a13.949,13.949,0,0,0,0,11.41ZM1401,1409a13.913,13.913,0,0,0,5.7-1.23l1.5,1.5a15.848,15.848,0,0,1-14.4,0l1.5-1.5A13.913,13.913,0,0,0,1401,1409Z"
                                      transform="translate(-1385 -1379)"
                                    />
                                  </svg>
                                </div>
                                <span
                                  class="sim-card-title"
                                  :style="`color:${BrandingJson['headerColorsHexCodeCustom']['inactiveButtonColor']}`"
                                  >Session</span
                                >
                              </div>
                              <div class="sim-icon-card-wrap">
                                <div
                                  class="
                                    sim-icon-card
                                    d-flex
                                    align-items-center
                                    justify-center
                                  "
                                  :style="`background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="22"
                                    height="22"
                                    viewBox="0 0 32 32"
                                  >
                                    <path
                                      :style="`fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']}`"
                                      id="round-table.svg"
                                      class="cls-1"
                                      d="M1415.27,1402.2l-1.49-1.5a13.949,13.949,0,0,0,0-11.41l1.49-1.49A15.848,15.848,0,0,1,1415.27,1402.2ZM1401,1405a10,10,0,1,1,10-10A10,10,0,0,1,1401,1405Zm0-18a8,8,0,1,0,8,8A8,8,0,0,0,1401,1387Zm0-6a13.953,13.953,0,0,0-5.71,1.22l-1.49-1.5a15.93,15.93,0,0,1,14.4,0l-1.49,1.5A13.988,13.988,0,0,0,1401,1381Zm-14.27,21.2a15.848,15.848,0,0,1,0-14.4l1.49,1.49a13.949,13.949,0,0,0,0,11.41ZM1401,1409a13.913,13.913,0,0,0,5.7-1.23l1.5,1.5a15.848,15.848,0,0,1-14.4,0l1.5-1.5A13.913,13.913,0,0,0,1401,1409Z"
                                      transform="translate(-1385 -1379)"
                                    />
                                  </svg>
                                </div>
                                <span
                                  class="sim-card-title"
                                  :style="`color:${BrandingJson['headerColorsHexCodeCustom']['inactiveButtonColor']}`"
                                  >Session</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="live-preview-simulator">
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' +
                          virtuallobby_data.coundownLobby.bgImageApp +
                          ')'
                        "
                      >
                        <div class="sim-wrapper">
                          <div
                            class="simulator-navigation d-flex align-center"
                            :style="`background-color:${BrandingJson['headerColorsHexCode']['topBar']}`"
                          >
                            <a href="#">
                              <svg
                                :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                width="30px"
                                height="30px"
                              >
                                <path
                                  d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                                />
                              </svg>
                            </a>
                            <label
                              v-show="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                              "
                              for="variable2"
                              class="color-picker-label change-nav-color"
                              @mouseenter="navColorChange"
                              @mouseleave="navColorDefault"
                            >
                              <img src="../../assets/images/color-picker.png" />
                              <input
                                id="variable2"
                                :disabled="
                                  BrandingJson.appColorHexCodeType !=
                                  'headerColorsHexCodeCustom'
                                "
                                v-model="
                                  BrandingJson['headerColorsHexCode']['topBar']
                                "
                                type="color"
                              />
                            </label>
                            <span
                              class="sim-page-title"
                              id="changeHeaderColor"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                  : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                              "
                              >Lobby</span
                            >
                          </div>
                          <div class="sim-welcome-text">
                            <h3
                              v-if="
                                virtuallobby_data &&
                                virtuallobby_data.coundownLobby
                              "
                              :style="`color:${virtuallobby_data.coundownLobby.HeaderTextColor}`"
                            >
                              Welcome {{ loggedInUserName }}
                            </h3>
                            <h4
                              v-if="
                                virtuallobby_data &&
                                virtuallobby_data.coundownLobby
                              "
                              :style="`color:${virtuallobby_data.coundownLobby.HeaderTextColor}`"
                            >
                              {{ currentEventName }}
                            </h4>
                          </div>
                          <div class="sim-lobby-cont">
                            <div class="d-flex flex-wrap">
                              <div
                                class="sim-icon-card-wrap"
                                v-for="(lobbyMenu, index) in SelectedLobbyMenu"
                                :key="lobbyMenu.MenuID"
                              >
                                <div
                                  class="
                                    sim-icon-card
                                    branding-icon-box-wrap
                                    d-flex
                                    align-items-center
                                    justify-center
                                  "
                                  id="simCardColorChange"
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']};`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']};`
                                      : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']};`
                                  "
                                >
                                  <label
                                    v-show="
                                      index == 0 &&
                                      BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeCustom'
                                    "
                                    for="variable3"
                                    class="color-picker-label"
                                  >
                                    <img
                                      src="../../assets/images/color-picker.svg"
                                      style="height: 16px; width: 16px"
                                    />
                                    <input
                                      id="variable3"
                                      :disabled="
                                        BrandingJson.appColorHexCodeType !=
                                        'headerColorsHexCodeCustom'
                                      "
                                      v-model="
                                        BrandingJson['headerColorsHexCode'][
                                          'sideNavigationAndIconColor'
                                        ]
                                      "
                                      type="color"
                                    />
                                  </label>
                                  <span
                                    v-for="icons in defaultSvgs.appIconSet"
                                    :key="icons.Name"
                                    style="
                                      display: inline-flex;
                                      justify-content: center;
                                      align-items: center;
                                    "
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="30px"
                                      height="30px"
                                      viewBox="0 0 75 75"
                                      v-if="icons.Name == lobbyMenu.Name"
                                    >
                                      <path
                                        :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                        id="round-table.svg"
                                        class="cls-1"
                                        :d="icons.svgd"
                                        :transform="icons.svgTransform"
                                      />
                                    </svg>
                                  </span>
                                </div>
                                <span
                                  class="sim-card-title"
                                  :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                  >{{ lobbyMenu.DisplayLabel }}</span
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="live-preview-simulator">
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' + appBackgroundImage + ')'
                        "
                      >
                        <div
                          class="
                            simulator-navigation
                            d-flex
                            align-center
                            justify-between
                          "
                          id="changeNavColor"
                          :style="`background-color:${BrandingJson['headerColorsHexCode']['topBar']}`"
                        >
                          <a href="#">
                            <svg
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="30px"
                              height="30px"
                            >
                              <path
                                d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                              />
                            </svg>
                          </a>
                          <span
                            class="sim-page-title ml-0 relative"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                            "
                          >
                            Attendees
                            <label
                              v-show="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                              "
                              @mouseenter="headercolorchanger"
                              @mouseleave="headercolorremove"
                              for="variable4"
                              class="color-picker-label headers-color-changes"
                            >
                              <img
                                src="../../assets/images/color-picker.svg"
                                style="height: 16px; width: 16px"
                              />
                              <div>
                                <input
                                  id="variable4"
                                  :disabled="
                                    BrandingJson.appColorHexCodeType !=
                                    'headerColorsHexCodeCustom'
                                  "
                                  v-model="
                                    BrandingJson['headerColorsHexCodeCustom'][
                                      'fontColorHeader'
                                    ]
                                  "
                                  type="color"
                                />
                              </div>
                            </label>
                          </span>
                          <span class="notification-holder">
                            <svg
                              data-v-1c4f105b=""
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              height="24px"
                              width="24px"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                            >
                              <path
                                data-v-1c4f105b=""
                                d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"
                              ></path>
                            </svg>
                          </span>
                        </div>
                        <div class="sim-attendee-listing-view">
                          <div
                            class="sim-search"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `background:${BrandingJson['headerColorsHexCodeCustom']['headerBar']}`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `background:${BrandingJson['headerColorsHexCodeLight']['headerBar']}`
                                : `background:${BrandingJson['headerColorsHexCodeDark']['headerBar']}`
                            "
                          >
                            <input
                              :style="`background:url(/img/search.2ca53f0d.svg) no-repeat 10px center ${BrandingJson['headerColorsHexCodeCustom']['cardBackground']};color: ${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']}`"
                              type="search"
                              id="searchBackgroundChange"
                              placeholder="Search by Name, Company, Title ...."
                            />
                          </div>
                          <div class="sim-attendee-list">
                            <div
                              id="changeBackgroundColor"
                              class="sim-attendee-card d-flex flex-wrap"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `background:${BrandingJson['headerColorsHexCodeLight']['cardBackground']}`
                                  : `background:${BrandingJson['headerColorsHexCodeDark']['cardBackground']}`
                              "
                              v-for="(attendee, index) in allAttendees"
                              :key="attendee.AttendeeId"
                            >
                              <div
                                class="
                                  sim-attendee-image
                                  attendee-branding-image-color
                                  d-flex
                                  align-items-center
                                  justify-content-center
                                "
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']}`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']}`
                                    : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']}`
                                "
                              >
                                {{
                                  attendee.Name.split(" ")
                                    .map((n) => n[0])
                                    .join("")
                                }}

                                <label
                                  v-show="
                                    index == 0 &&
                                    BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                  "
                                  for="variable5"
                                  @mouseenter="mouseenter"
                                  @mouseleave="mouseleave"
                                  class="
                                    color-picker-label
                                    change-attendee-imagebox-color
                                  "
                                >
                                  <img
                                    src="../../assets/images/color-picker.svg"
                                  />
                                  <input
                                    id="variable5"
                                    :disabled="
                                      BrandingJson.appColorHexCodeType !=
                                      'headerColorsHexCodeCustom'
                                    "
                                    v-model="
                                      BrandingJson['headerColorsHexCodeCustom'][
                                        'fontColorSubHeader'
                                      ]
                                    "
                                    type="color"
                                  />
                                </label>
                              </div>
                              <div
                                class="
                                  sim-attendee-name-details
                                  d-flex
                                  flex-wrap
                                "
                              >
                                <div class="texts relative">
                                  <h5
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                        : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                                    "
                                  >
                                    {{ attendee.Name }}
                                  </h5>
                                  <p
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                        : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                                    "
                                  >
                                    {{ attendee.Designation }}
                                  </p>
                                  <p
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                        : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                                    "
                                  >
                                    {{ attendee.Company }}
                                  </p>
                                </div>
                                <a
                                  href="#"
                                  class="sim-bookmark"
                                  style="width: 24px"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    height="24px"
                                    width="24px"
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                        : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                                    "
                                  >
                                    <path
                                      d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"
                                    />
                                  </svg>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            sim-bottom-navigation
                            d-flex
                            flex-wrap
                            justify-around
                          "
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']};`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']};`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']};`
                          "
                        >
                          <div
                            class="sim-bottom-navigation-item"
                            v-for="bottomMenu in SelectedBottomMenu"
                            :key="bottomMenu.MenuID"
                          >
                            <span>
                              <span
                                v-for="icons in defaultSvgs.appIconSet"
                                :key="icons.Name"
                              >
                                <svg
                                  v-if="icons.Name == bottomMenu.Name"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 83.812 69"
                                >
                                  <path
                                    id="dynamic.svg"
                                    class="cls-1"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    :d="icons.svgd"
                                    :transform="icons.svgTransform"
                                  />
                                </svg>
                              </span>
                            </span>
                            <p
                              :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                            >
                              {{ bottomMenu.DisplayLabel }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="live-preview-simulator">
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' + appBackgroundImage + ')'
                        "
                      >
                        <div
                          class="
                            simulator-navigation
                            d-flex
                            align-center
                            justify-between
                          "
                          :style="`background-color:${BrandingJson['headerColorsHexCode']['topBar']}`"
                        >
                          <a href="#">
                            <svg
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="30px"
                              height="30px"
                            >
                              <path
                                d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                              />
                            </svg>
                          </a>
                          <span
                            class="sim-page-title ml-0 relative"
                            id="colorChangerHeader2"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                            "
                          >
                            Attendee Details
                          </span>
                          <span class="notification-holder">
                            <svg
                              data-v-1c4f105b=""
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              height="24px"
                              width="24px"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                            >
                              <path
                                data-v-1c4f105b=""
                                d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"
                              ></path>
                            </svg>
                          </span>
                        </div>
                        <div
                          class="sim-attendee-details relative"
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['cardBackground']}`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['cardBackground']}`
                          "
                        >
                          <label
                            v-show="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                            "
                            for="variable6"
                            class="
                              color-picker-label
                              attendee-details-color-change
                            "
                            @mouseenter="colorchangeenter"
                            @mouseleave="colorchangeremove"
                          >
                            <img
                              src="../../assets/images/color-picker.svg"
                              style="height: 16px; width: 16px"
                            />
                            <input
                              id="variable6"
                              :disabled="
                                BrandingJson.appColorHexCodeType !=
                                'headerColorsHexCodeCustom'
                              "
                              v-model="
                                BrandingJson['headerColorsHexCodeCustom'][
                                  'cardBackground'
                                ]
                              "
                              type="color"
                            />
                          </label>
                          <div
                            class="
                              sim-attendee-d-image
                              attendee-branding-image-color
                              d-flex
                              align-items-center
                              justify-content-center
                            "
                            id="attendeeDetailsBranding"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']}`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']}`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};background:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']}`
                            "
                          >
                            {{
                              loggedInUserName
                                .split(" ")
                                .map((n) => n[0])
                                .join("")
                            }}
                          </div>
                          <h5
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                            "
                          >
                            {{ loggedInUserName }}
                          </h5>
                          <p
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                            "
                          >
                            Designation
                          </p>
                          <p
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                            "
                          >
                            Company
                          </p>
                          <div class="sim-attendee-desc">
                            <div
                              class="
                                sim-desc-tabs
                                relative
                                d-flex
                                justify-center
                              "
                              :style="`background:${BrandingJson['headerColorsHexCode']['headerBar']}`"
                            >
                              <div class="sim-tab-link-holder relative">
                                <label
                                  v-show="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                  "
                                  for="variable10"
                                  class="color-picker-label"
                                >
                                  <img
                                    src="../../assets/images/color-picker.png"
                                  />
                                  <input
                                    id="variable10"
                                    :disabled="
                                      BrandingJson.appColorHexCodeType !=
                                      'headerColorsHexCodeCustom'
                                    "
                                    v-model="
                                      BrandingJson['headerColorsHexCodeCustom'][
                                        'tabSelectionColor'
                                      ]
                                    "
                                    type="color"
                                  />
                                </label>
                                <a
                                  href="#"
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `color:${BrandingJson['headerColorsHexCodeCustom']['tabSelectionColor']};`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `color:${BrandingJson['headerColorsHexCodeLight']['tabSelectionColor']};`
                                      : `color:${BrandingJson['headerColorsHexCodeDark']['tabSelectionColor']};`
                                  "
                                  >Description<span
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `background:${BrandingJson['headerColorsHexCodeCustom']['tabSelectionColor']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `background:${BrandingJson['headerColorsHexCodeLight']['tabSelectionColor']};`
                                        : `background:${BrandingJson['headerColorsHexCodeDark']['tabSelectionColor']};`
                                    "
                                  ></span
                                ></a>
                              </div>
                              <div class="sim-tab-link-holder">
                                <a
                                  href="#"
                                  :style="`color:${BrandingJson['headerColorsHexCode']['fontBar']}`"
                                  >Contact</a
                                >
                              </div>
                              <label
                                v-show="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                "
                                for="variable7"
                                class="color-picker-label"
                              >
                                <img
                                  src="../../assets/images/color-picker.png"
                                />
                                <input
                                  id="variable7"
                                  :disabled="
                                    BrandingJson.appColorHexCodeType !=
                                    'headerColorsHexCodeCustom'
                                  "
                                  v-model="
                                    BrandingJson['headerColorsHexCode'][
                                      'headerBar'
                                    ]
                                  "
                                  type="color"
                                />
                              </label>
                            </div>
                            <div class="sim-tab-cont">
                              <p
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                    : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                                "
                              >
                                This is a test description.
                              </p>
                            </div>
                            <div class="sim-buttons">
                              <a
                                href="#"
                                :style="`background:${BrandingJson['headerColorsHexCode']['activeButtonColor']};color:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                id="requestMeetingButtonColorChange"
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 98 69"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12.5145 15.9599C8.21794 15.9599 4.73522 12.3872 4.73522 7.97996C4.73522 3.57273 8.21794 0 12.5145 0C16.8111 0 20.2938 3.57273 20.2938 7.97996C20.2938 12.3872 16.8111 15.9599 12.5145 15.9599Z"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                  />
                                  <path
                                    d="M25.029 29.9248C25.029 25.8849 21.6969 22.6099 17.588 22.6099H7.44106C3.3321 22.6099 0 25.8849 0 29.9248V40.5648C0 48.2775 6.36031 54.5297 14.2057 54.5297H24.3526V63.8397C24.3526 66.4107 26.4731 68.4946 29.0878 68.4946C31.7025 68.4946 33.823 66.4107 33.823 63.8397V43.2248C33.823 38.3068 29.9439 34.2791 25.029 33.9382V29.9248Z"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                  />
                                  <path
                                    d="M85.4855 15.9599C89.7821 15.9599 93.2648 12.3872 93.2648 7.97996C93.2648 3.57273 89.7821 0 85.4855 0C81.1889 0 77.7062 3.57273 77.7062 7.97996C77.7062 12.3872 81.1889 15.9599 85.4855 15.9599Z"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                  />
                                  <path
                                    d="M72.971 29.9248C72.971 25.8849 76.3031 22.6099 80.412 22.6099H90.5589C94.6679 22.6099 98 25.8849 98 29.9248V40.5648C98 48.2775 91.6397 54.5297 83.7943 54.5297H73.6474V63.8397C73.6474 66.4107 71.5269 68.4946 68.9122 68.4946C66.2975 68.4946 64.177 66.4107 64.177 63.8397V43.2248C64.177 38.3068 68.0561 34.2791 72.971 33.9382V29.9248Z"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                  />
                                  <path
                                    d="M33.823 29.0452C33.823 26.4116 36.0388 24.2766 38.772 24.2766H59.228C61.9612 24.2766 64.177 26.4116 64.177 29.0452C64.177 31.6788 61.9612 33.8138 59.228 33.8138H51.1681V65.0265H52.0354C52.9933 65.0265 53.7699 65.8029 53.7699 66.7606C53.7699 67.7183 52.9933 68.4946 52.0354 68.4946H46.8319C45.8739 68.4946 45.0973 67.7183 45.0973 66.7606C45.0973 65.8029 45.8739 65.0265 46.8319 65.0265H47.6991V33.8138H38.772C36.0388 33.8138 33.823 31.6788 33.823 29.0452Z"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};`"
                                  />
                                </svg>
                                Request Meeting
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            sim-bottom-navigation
                            d-flex
                            flex-wrap
                            justify-around
                          "
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']};`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']};`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']};`
                          "
                        >
                          <div
                            class="sim-bottom-navigation-item"
                            v-for="bottomMenu in SelectedBottomMenu"
                            :key="bottomMenu.MenuID"
                          >
                            <span>
                              <span
                                v-for="icons in defaultSvgs.appIconSet"
                                :key="icons.Name"
                              >
                                <svg
                                  v-if="icons.Name == bottomMenu.Name"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 83.812 69"
                                >
                                  <path
                                    id="dynamic.svg"
                                    class="cls-1"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    :d="icons.svgd"
                                    :transform="icons.svgTransform"
                                  />
                                </svg>
                              </span>
                            </span>
                            <p
                              :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                            >
                              {{ bottomMenu.DisplayLabel }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="live-preview-simulator"
                    v-if="allExhibitors && allExhibitors.length > 0"
                  >
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' + appBackgroundImage + ')'
                        "
                      >
                        <div
                          class="
                            simulator-navigation
                            d-flex
                            align-center
                            justify-between
                          "
                          :style="`background-color:${BrandingJson['headerColorsHexCode']['topBar']}`"
                        >
                          <a href="#">
                            <svg
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="30px"
                              height="30px"
                            >
                              <path
                                d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                              />
                            </svg>
                          </a>
                          <span
                            class="sim-page-title ml-0 relative"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                            "
                          >
                            Exhibits
                          </span>
                          <span class="notification-holder">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                            >
                              <path
                                id="notification.svg"
                                class="cls-1"
                                style="fill-rule: evenodd"
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                    : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                                "
                                d="M1326,153h-16a1.03,1.03,0,0,1-1-1,1.075,1.075,0,0,1,1-1h1v-6a6.976,6.976,0,0,1,6.02-6.9c0-.033-0.02-0.068-0.02-0.1v-1a1,1,0,0,1,1-1,1.1,1.1,0,0,1,1,1v1c0,0.031-.02.066-0.02,0.1A6.977,6.977,0,0,1,1325,145v6h1a1.007,1.007,0,0,1,1,1A1.1,1.1,0,0,1,1326,153Zm-3-8a5,5,0,0,0-10,0v6h10v-6Zm-6,9h2a1.007,1.007,0,0,1,1,1,1.1,1.1,0,0,1-1,1h-2a1.03,1.03,0,0,1-1-1A1.075,1.075,0,0,1,1317,154Z"
                                transform="translate(-1309 -136)"
                              />
                            </svg>
                            <i>10</i>
                          </span>
                        </div>
                        <div class="sim-attendee-listing-view">
                          <div
                            class="sim-search"
                            :style="`background:${BrandingJson['headerColorsHexCode']['headerBar']}`"
                          >
                            <input
                              :style="`background:url(/img/search.2ca53f0d.svg) no-repeat 10px center ${BrandingJson['headerColorsHexCodeCustom']['cardBackground']};color: ${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']}`"
                              type="search"
                              placeholder="Search by Name or keywords"
                            />
                          </div>
                          <div class="sim-attendee-list">
                            <div
                              id="changeBackgroundColor2"
                              class="sim-attendee-card d-flex flex-wrap"
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `background:${BrandingJson['headerColorsHexCodeLight']['cardBackground']}`
                                  : `background:${BrandingJson['headerColorsHexCodeDark']['cardBackground']}`
                              "
                              v-for="(exhibitor, index) in allExhibitors"
                              :key="exhibitor.ExhibitorId"
                            >
                              <div class="sim-sponsors-logo">
                                <img
                                  v-if="exhibitor.Logo"
                                  :src="exhibitor.Logo"
                                  alt="Sponsor Name"
                                />
                              </div>
                              <div
                                class="
                                  sim-attendee-name-details
                                  d-flex
                                  flex-wrap
                                "
                              >
                                <div class="texts">
                                  <h5
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                        : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                                    "
                                  >
                                    {{ exhibitor.Name }}
                                  </h5>
                                  <span
                                    :style="`color:${BrandingJson['headerColorsHexCode']['activeButtonColor']};border:1px solid ${BrandingJson['headerColorsHexCode']['activeButtonColor']};`"
                                    >Gold</span
                                  >
                                </div>
                                <div class="sim-bookmark-holder relative">
                                  <label
                                    v-show="
                                      index == 0 &&
                                      BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeCustom'
                                    "
                                    for="variable12"
                                    class="color-picker-label"
                                  >
                                    <img
                                      src="../../assets/images/color-picker.png"
                                    />
                                    <input
                                      id="variable12"
                                      :disabled="
                                        BrandingJson.appColorHexCodeType !=
                                        'headerColorsHexCodeCustom'
                                      "
                                      v-model="
                                        BrandingJson[
                                          'headerColorsHexCodeCustom'
                                        ]['iconBackground']
                                      "
                                      type="color"
                                    />
                                  </label>
                                  <a href="#" class="sim-bookmark">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      height="24px"
                                      width="24px"
                                      :style="
                                        BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeCustom'
                                          ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                          : BrandingJson.appColorHexCodeType ===
                                            'headerColorsHexCodeLight'
                                          ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                          : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                                      "
                                    >
                                      <path
                                        d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"
                                      />
                                    </svg>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            sim-bottom-navigation
                            d-flex
                            flex-wrap
                            justify-around
                          "
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']};`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']};`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']};`
                          "
                        >
                          <div
                            class="sim-bottom-navigation-item"
                            v-for="bottomMenu in SelectedBottomMenu"
                            :key="bottomMenu.MenuID"
                          >
                            <span>
                              <span
                                v-for="icons in defaultSvgs.appIconSet"
                                :key="icons.Name"
                              >
                                <svg
                                  v-if="icons.Name == bottomMenu.Name"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 83.812 69"
                                >
                                  <path
                                    id="dynamic.svg"
                                    class="cls-1"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    :d="icons.svgd"
                                    :transform="icons.svgTransform"
                                  />
                                </svg>
                              </span>
                            </span>
                            <p
                              :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                            >
                              {{ bottomMenu.DisplayLabel }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="live-preview-simulator"
                    v-if="allExhibitors && allExhibitors.length > 0"
                  >
                    <div class="simulator-wrap">
                      <figure>
                        <img src="../../assets/images/mobile-frame.png" />
                      </figure>
                      <div
                        class="preview-content"
                        :style="
                          'background-image: url(' + appBackgroundImage + ')'
                        "
                      >
                        <div
                          class="
                            simulator-navigation
                            d-flex
                            align-center
                            justify-between
                          "
                          :style="`background-color:${BrandingJson['headerColorsHexCode']['topBar']}`"
                        >
                          <a href="#">
                            <svg
                              :style="
                                BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeCustom'
                                  ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                  : BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeLight'
                                  ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                  : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                              "
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="30px"
                              height="30px"
                            >
                              <path
                                d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"
                              />
                            </svg>
                          </a>
                          <span
                            class="sim-page-title ml-0 relative"
                            :style="
                              BrandingJson.appColorHexCodeType ===
                              'headerColorsHexCodeCustom'
                                ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                : BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeLight'
                                ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                            "
                          >
                            Exhibits Details
                          </span>
                          <span class="notification-holder">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                            >
                              <path
                                id="notification.svg"
                                class="cls-1"
                                style="fill-rule: evenodd"
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                    : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                                "
                                d="M1326,153h-16a1.03,1.03,0,0,1-1-1,1.075,1.075,0,0,1,1-1h1v-6a6.976,6.976,0,0,1,6.02-6.9c0-.033-0.02-0.068-0.02-0.1v-1a1,1,0,0,1,1-1,1.1,1.1,0,0,1,1,1v1c0,0.031-.02.066-0.02,0.1A6.977,6.977,0,0,1,1325,145v6h1a1.007,1.007,0,0,1,1,1A1.1,1.1,0,0,1,1326,153Zm-3-8a5,5,0,0,0-10,0v6h10v-6Zm-6,9h2a1.007,1.007,0,0,1,1,1,1.1,1.1,0,0,1-1,1h-2a1.03,1.03,0,0,1-1-1A1.075,1.075,0,0,1,1317,154Z"
                                transform="translate(-1309 -136)"
                              />
                            </svg>
                            <i>10</i>
                          </span>
                        </div>
                        <div
                          class="sm-exhibits-details"
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['cardBackground']}`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['cardBackground']}`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['cardBackground']}`
                          "
                        >
                          <div class="sm-spons-logo-wrap d-flex flex-wrap">
                            <div class="sim-sp-logo">
                              <img
                                v-if="allExhibitors && allExhibitors[0]"
                                :src="allExhibitors[0].Logo"
                                alt="Sponsor Name"
                              />
                            </div>
                            <div class="sim-sponsor-text d-flex flex-wrap">
                              <div class="left-text">
                                <h5
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorHeader']};`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorHeader']};`
                                      : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorHeader']};`
                                  "
                                >
                                  {{ allExhibitors[0].Name }}
                                </h5>
                                <span
                                  :style="`color:${BrandingJson['headerColorsHexCode']['activeButtonColor']};border:1px solid ${BrandingJson['headerColorsHexCode']['activeButtonColor']};`"
                                  >Gold</span
                                >
                              </div>
                              <a href="#">
                                <svg
                                  data-v-1c4f105b=""
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  height="24px"
                                  width="24px"
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `fill:${BrandingJson['headerColorsHexCodeCustom']['iconBackground']};`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `fill:${BrandingJson['headerColorsHexCodeLight']['iconBackground']};`
                                      : `fill:${BrandingJson['headerColorsHexCodeDark']['iconBackground']};`
                                  "
                                >
                                  <path
                                    data-v-1c4f105b=""
                                    d="M17,18L12,15.82L7,18V5H17M17,3H7A2,2 0 0,0 5,5V21L12,18L19,21V5C19,3.89 18.1,3 17,3Z"
                                  ></path>
                                </svg>
                              </a>
                            </div>
                          </div>
                          <div class="sp-logo-link d-flex flex-wrap">
                            <div class="sp-logo-link-holder relative">
                              <label
                                v-show="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                "
                                @mouseenter="changebtnback"
                                @mouseleave="changebtndefault"
                                for="variable8"
                                class="
                                  color-picker-label
                                  exchange-button-color-change
                                "
                              >
                                <img
                                  src="../../assets/images/color-picker.svg"
                                  style="height: 16px; width: 16px"
                                />
                                <input
                                  id="variable8"
                                  :disabled="
                                    BrandingJson.appColorHexCodeType !=
                                    'headerColorsHexCodeCustom'
                                  "
                                  v-model="
                                    BrandingJson['headerColorsHexCode'][
                                      'activeButtonColor'
                                    ]
                                  "
                                  type="color"
                                />
                              </label>
                              <a
                                href="#"
                                :style="`background:${BrandingJson['headerColorsHexCode']['activeButtonColor']};color:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};border:1px solid ${BrandingJson['headerColorsHexCode']['activeButtonColor']};`"
                                id="exchangebuttonchange"
                              >
                                <span class="sim-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 37 29"
                                  >
                                    <path
                                      id="exchange-business-card.svg"
                                      :style="`fill:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']}`"
                                      class="cls-1"
                                      d="M2122,1772h-1v-11a1,1,0,0,0-1-1h-17v-1a2.006,2.006,0,0,1,2-2h17a2.006,2.006,0,0,1,2,2v11A2,2,0,0,1,2122,1772Zm-22-18h-6v-4h6v-2l5,4-5,4v-2Zm-2,6h-6v2l-5-4,5-4v2h6v4Zm2,2h17a2.006,2.006,0,0,1,2,2v11a2,2,0,0,1-2,2h-17a1.993,1.993,0,0,1-2-2v-11A2,2,0,0,1,2100,1762Zm10,10h5a1,1,0,0,0,0-2h-5A1,1,0,0,0,2110,1772Zm0-4h5a1,1,0,0,0,0-2h-5A1,1,0,0,0,2110,1768Zm-9,3a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1v-4a1,1,0,0,0-1-1h-4a1,1,0,0,0-1,1v4Z"
                                      transform="translate(-2087 -1748)"
                                    />
                                  </svg>
                                </span>
                                <span
                                  :style="`color:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']}`"
                                  class="sim-btn-text"
                                >
                                  Exchange Business Card
                                </span>
                              </a>
                            </div>
                            <div class="sp-logo-link-holder relative">
                              <label
                                v-show="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                "
                                for="variable9"
                                class="
                                  color-picker-label
                                  roundtable-button-colorchange
                                "
                                @mouseenter="exchangeBtnFontColor"
                                @mouseleave="exchangeBtnFontDefault"
                              >
                                <img
                                  src="../../assets/images/color-picker.svg"
                                  style="height: 16px; width: 16px"
                                />
                                <input
                                  id="variable9"
                                  :disabled="
                                    BrandingJson.appColorHexCodeType !=
                                    'headerColorsHexCodeCustom'
                                  "
                                  v-model="
                                    BrandingJson['headerColorsHexCode'][
                                      'inactiveButtonColor'
                                    ]
                                  "
                                  type="color"
                                />
                              </label>
                              <a
                                href="#"
                                :style="`background:${BrandingJson['headerColorsHexCode']['inactiveButtonColor']};color:${BrandingJson['headerColorsHexCode']['activeButtonColor']};border:1px solid ${BrandingJson['headerColorsHexCode']['activeButtonColor']};`"
                                id="joinRoundTableColorChanger"
                              >
                                <span class="sim-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20px"
                                    height="20"
                                    viewBox="0 0 82 79.563"
                                  >
                                    <path
                                      :style="`fill:${BrandingJson['headerColorsHexCode']['activeButtonColor']}`"
                                      id="rt.svg"
                                      class="cls-1"
                                      d="M267.617,61.331l-6.209-1.748a35.138,35.138,0,0,0-.1-19.138l6.211-1.748A40.526,40.526,0,0,1,267.617,61.331ZM236.683,84.113a34.352,34.352,0,0,0,16.3-9.622l4.466,4.356a40.934,40.934,0,0,1-19.277,11.1Zm-0.089-67.875,1.488-5.847a40.93,40.93,0,0,1,19.181,10.941l-4.472,4.361A34.329,34.329,0,0,0,236.594,16.237ZM255,50a27,27,0,1,1-27-27A27,27,0,0,1,255,50ZM228,29.5A20.5,20.5,0,1,0,248.5,50,20.5,20.5,0,0,0,228,29.5ZM203.276,26l-4.484-4.373a40.932,40.932,0,0,1,19.145-11.16l1.491,5.858A34.363,34.363,0,0,0,203.276,26Zm16.065,58.018-1.489,5.846a40.95,40.95,0,0,1-19.24-11.318l4.48-4.368A34.383,34.383,0,0,0,219.341,84.019Zm-24.425-24.6-6.223,1.751a40.6,40.6,0,0,1,.1-22.318l6.225,1.752A35.17,35.17,0,0,0,194.916,59.422Z"
                                      transform="translate(-187.188 -10.375)"
                                    />
                                  </svg>
                                </span>
                                <span
                                  class="sim-btn-text"
                                  :style="`color:${BrandingJson['headerColorsHexCode']['activeButtonColor']}`"
                                >
                                  Join Round Table
                                </span>
                              </a>
                            </div>
                          </div>
                          <div class="sim-attendee-desc">
                            <div
                              class="sim-desc-tabs d-flex justify-center"
                              :style="`background:${BrandingJson['headerColorsHexCode']['headerBar']}`"
                            >
                              <div class="sim-tab-link-holder">
                                <a
                                  href="#"
                                  :style="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                      ? `color:${BrandingJson['headerColorsHexCodeCustom']['tabSelectionColor']};`
                                      : BrandingJson.appColorHexCodeType ===
                                        'headerColorsHexCodeLight'
                                      ? `color:${BrandingJson['headerColorsHexCodeLight']['tabSelectionColor']};`
                                      : `color:${BrandingJson['headerColorsHexCodeDark']['tabSelectionColor']};`
                                  "
                                  >Description<span
                                    :style="
                                      BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeCustom'
                                        ? `background:${BrandingJson['headerColorsHexCodeCustom']['tabSelectionColor']};`
                                        : BrandingJson.appColorHexCodeType ===
                                          'headerColorsHexCodeLight'
                                        ? `background:${BrandingJson['headerColorsHexCodeLight']['tabSelectionColor']};`
                                        : `background:${BrandingJson['headerColorsHexCodeDark']['tabSelectionColor']};`
                                    "
                                  ></span
                                ></a>
                              </div>
                              <div class="sim-tab-link-holder relative">
                                <label
                                  v-show="
                                    BrandingJson.appColorHexCodeType ===
                                    'headerColorsHexCodeCustom'
                                  "
                                  for="variable11"
                                  class="color-picker-label"
                                >
                                  <img
                                    src="../../assets/images/color-picker.png"
                                  />
                                  <input
                                    id="variable11"
                                    :disabled="
                                      BrandingJson.appColorHexCodeType !=
                                      'headerColorsHexCodeCustom'
                                    "
                                    v-model="
                                      BrandingJson['headerColorsHexCode'][
                                        'fontBar'
                                      ]
                                    "
                                    type="color"
                                  />
                                </label>
                                <a
                                  href="#"
                                  :style="`color:${BrandingJson['headerColorsHexCode']['fontBar']}`"
                                  >Contact</a
                                >
                              </div>
                            </div>
                            <div class="sim-tab-cont">
                              <p
                                :style="
                                  BrandingJson.appColorHexCodeType ===
                                  'headerColorsHexCodeCustom'
                                    ? `color:${BrandingJson['headerColorsHexCodeCustom']['fontColorSubHeader']};`
                                    : BrandingJson.appColorHexCodeType ===
                                      'headerColorsHexCodeLight'
                                    ? `color:${BrandingJson['headerColorsHexCodeLight']['fontColorSubHeader']};`
                                    : `color:${BrandingJson['headerColorsHexCodeDark']['fontColorSubHeader']};`
                                "
                              >
                                This is a test description.
                              </p>
                            </div>
                          </div>
                        </div>
                        <div
                          class="
                            sim-bottom-navigation
                            d-flex
                            flex-wrap
                            justify-around
                          "
                          :style="
                            BrandingJson.appColorHexCodeType ===
                            'headerColorsHexCodeCustom'
                              ? `background:${BrandingJson['headerColorsHexCodeCustom']['navigationBackgroundColor']};`
                              : BrandingJson.appColorHexCodeType ===
                                'headerColorsHexCodeLight'
                              ? `background:${BrandingJson['headerColorsHexCodeLight']['navigationBackgroundColor']};`
                              : `background:${BrandingJson['headerColorsHexCodeDark']['navigationBackgroundColor']};`
                          "
                        >
                          <div
                            class="sim-bottom-navigation-item"
                            v-for="bottomMenu in SelectedBottomMenu"
                            :key="bottomMenu.MenuID"
                          >
                            <span>
                              <span
                                v-for="icons in defaultSvgs.appIconSet"
                                :key="icons.Name"
                              >
                                <svg
                                  v-if="icons.Name == bottomMenu.Name"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24px"
                                  height="24px"
                                  viewBox="0 0 83.812 69"
                                >
                                  <path
                                    id="dynamic.svg"
                                    class="cls-1"
                                    :style="`fill:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                                    :d="icons.svgd"
                                    :transform="icons.svgTransform"
                                  />
                                </svg>
                              </span>
                            </span>
                            <p
                              :style="`color:${BrandingJson['headerColorsHexCode']['sideNavigationAndIconColor']}`"
                            >
                              {{ bottomMenu.DisplayLabel }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Background" @click="showSubmitButton = true">
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col md:w-1-12 w-full mt-5">
                  <h4 class="mb-3">Background Image</h4>
                  <p>
                    Upload the logo for the event. Follow the directions for
                    image size &amp; format.
                  </p>
                  <br />
                  <p>
                    Manage your Background screen from here. If you are creating
                    a new event, and wish that the event will have a splash or
                    welcome screen then please enable it using Yes. You will
                    need to upload new images for each of the sizes mentioned.
                    The Screen (9:16) is a universal size you will provide an
                    image in hi-resolution and we will resize it for different
                    phone sized as applicable.
                  </p>
                </div>

                <div class="vx-col md:w-1/1 w-full mt-8">
                  <h4 class="choose-color-head">Background</h4>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2">
                      <div
                        class="single-color-bar"
                        v-if="!BrandingJson['EventInfo']['UseBackgroundImage']"
                      >
                        <label style="width: 100%">Background Color</label>
                        <input
                          v-model="BrandingJson['EventInfo']['BackgroundColor']"
                          type="color"
                        />
                      </div>
                    </div>
                    <div class="vx-col md:w-1/2">
                      <div class="single-color-bar">
                        <label style="width: 100%">Body Text Color</label>
                        <input
                          v-model="BrandingJson['EventInfo']['BodyTextColor']"
                          type="color"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2">
                      <div class="demo-alignment image-opt">
                        <span>Or Choose a Background Image</span>
                        <div class="mt-4">
                          <vs-switch
                            v-model="
                              BrandingJson['EventInfo']['UseBackgroundImage']
                            "
                            name="UseBackgroundImage"
                          >
                          </vs-switch>
                        </div>
                      </div>
                    </div>
                    <div
                      class="vx-col md:w-1/2"
                      v-if="BrandingJson['EventInfo']['UseBackgroundImage']"
                    >
                      <vs-switch
                        class="mt-4"
                        color="dark"
                        v-model="
                          BrandingJson['EventInfo']['DefaultGallerySelected']
                        "
                        style="width: 150px"
                      >
                        <span slot="on">Select Default Image</span>
                        <span slot="off">Upload Custom Image</span>
                      </vs-switch>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="vx-row p-3"
                v-if="
                  BrandingJson['EventInfo']['UseBackgroundImage'] &&
                  BrandingJson['EventInfo']['DefaultGallerySelected']
                "
              >
                <div
                  class="vx-col md:w-1/3 w-full"
                  v-for="(item, index) in GalleryImages"
                  :key="index"
                >
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img :src="item.ThumbImg" />
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <label
                        >{{ item.Name }}
                        <input
                          class="ml-2"
                          type="radio"
                          @click="
                            BrandingJson['EventInfo']['DefaultGalleryImage'] =
                              item
                          "
                          :checked="
                            item.Folder ==
                            BrandingJson['EventInfo']['DefaultGalleryImage']
                              .Folder
                              ? true
                              : false
                          "
                        />
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="vx-row p-3"
                v-if="
                  BrandingJson['EventInfo']['UseBackgroundImage'] &&
                  !BrandingJson['EventInfo']['DefaultGallerySelected']
                "
              >
                <div class="vx-col md:w-1/3 w-full">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['2732x2048']"
                        :src="BrandingJson['eventBGImage']['2732x2048']"
                      />

                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '2732x2048',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '2732x2048',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />

                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 2732x2048 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['2048x2732']"
                        :src="BrandingJson['eventBGImage']['2048x2732']"
                      />

                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '2048x2732',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '2048x2732',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />

                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 2048x2732 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['1440x2560']"
                        :src="BrandingJson['eventBGImage']['1440x2560']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1440x2560',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1440x2560',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />

                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1440x2560 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['1125x2436']"
                        :src="BrandingJson['eventBGImage']['1125x2436']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1125x2436',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1125x2436',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1125x2436 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['1080x1920']"
                        :src="BrandingJson['eventBGImage']['1080x1920']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1080x1920',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1080x1920',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1080x1920 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['1242x2688']"
                        :src="BrandingJson['eventBGImage']['1242x2688']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1242x2688',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1242x2688',
                            'eventBGImage'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1242x2688 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload event-bg-wrap">
                    <div class="event-background-wrap big-splash my-3">
                      <img
                        v-if="BrandingJson['eventBGImage']['640x960']"
                        :src="BrandingJson['eventBGImage']['640x960']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '640x960',
                              'eventBGImage'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson($event, '640x960', 'eventBGImage')
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 640x960 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>
          <!-- <vs-tab label="Banner">
                        <div class="tab-text">
                            <div class="vx-row">
                                <div class="vx-col md:w-1-12 w-full mt-5">
                                    <h4 class="mb-3">Banner Image</h4>
                                    <p>
                                        You need to upload all images or go for all images as set
                                    </p>
                                </div>
                                <div class="vx-col md:w-1/2 w-full mt-3">
                                  <label>Target Link: </label>
                                  <div class="default-theme-wrapper ml-3">
                                    <div class="radio-wrapper mt-3">
                                      <vs-radio class="mr-2" v-model="BrandingJson.banner.TargetLink" vs-value="NoLink">No Link</vs-radio>
                                      <vs-radio class="mr-2" v-model="BrandingJson.banner.TargetLink" vs-value="External">External Link</vs-radio>
                                      <vs-radio class="mr-2" v-model="BrandingJson.banner.TargetLink" vs-value="Internal">Internal Link</vs-radio>
                                    </div>
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full">
                                  <div v-if="BrandingJson.banner.TargetLink=='External'">
                                    <label>URL / Link</label>
                                    <vs-input class="w-full" v-model="BrandingJson.banner.ExternalLink"/>
                                  </div>
                                  <div v-if="BrandingJson.banner.TargetLink=='Internal'">
                                    <label>Choose a section</label>
                                    <v-select
                                      class="w-full select-large"
                                      v-model="BrandingJson.banner.InternalLink"
                                      :options="landingURLOptions"
                                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                    />
                                  </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPhone 5
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-brandingbanner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['640x88']"
                                                :src="BrandingJson['banner']['640x88']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '640x88', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '640x88', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 640x88 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPhone 6
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['750x103']"
                                                :src="BrandingJson['banner']['750x103']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '750x103', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '750x103', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 750x103 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPhone 10/11/12
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['1125x156']"
                                                :src="BrandingJson['banner']['1125x156']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '1125x156', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '1125x156', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 1125x156 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1/2 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPhone 6+
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['1242x171']"
                                                :src="BrandingJson['banner']['1242x171']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '1242x171', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '1242x171', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 1242x171 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1-12 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            All Android Phone
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['1440x176']"
                                                :src="BrandingJson['banner']['1440x176']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '1440x176', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '1440x176', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 1440x176 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1-12 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPad landscape
                                            <span>*</span> / Desktop
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['2732x88']"
                                                :src="BrandingJson['banner']['2732x88']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '2732x88', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '2732x88', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 2732x88 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-col md:w-1-12 w-full banner-single-wrap">
                                    <p class="device-name">
                                        <strong>
                                            iPad Portrait
                                            <span>*</span>
                                        </strong>
                                    </p>
                                    <div class="event-icon-upload custom-branding-banner-wrap">
                                        <div class="single-banner">
                                            <img v-if="BrandingJson['banner']['2048x88']"
                                                :src="BrandingJson['banner']['2048x88']" />
                                            <span class="img-delete-butn">
                                                <button @click="
                              deleteBrandingJson($event, '2048x88', 'banner')
                            ">
                                                    <img src="../../assets/images/btn-del.png" />
                                                </button>
                                            </span>
                                        </div>
                                        <div class="choose-file-area">
                                            <input type="file" @change="
                            uploadBrandingJson($event, '2048x88', 'banner')
                          " accept="image/*" />
                                            <div class="image-specification">
                                                <p>
                                                    <strong>Image Specification</strong>
                                                </p>
                                                <p>
                                                    Dimension: (Width x Height) 2048x88 pixels;
                                                    Format:JPG/PNG 72DPI
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab> -->
          <vs-tab label="Event Banners" @click="showSubmitButton = true">
            <event-banners
              ref="event-banners"
              :key="compkey + 1"
              :BrandingJson="BrandingJson"
              :landingURLOptions="landingURLOptions"
              @showSubmitButton="showHideSubmitButton"
              @saveEventBanner="formSubmittedt4"
            />
          </vs-tab>
          <vs-tab label="Splash" @click="showSubmitButton = true">
            <div class="tab-text">
              <div class="vx-row my-5">
                <div class="vx-col md:w-1-12 w-full mt-5">
                  <h4 class="mb-3">Splash/Welcome Screen Images</h4>
                  <p>
                    Manage your Splash / Welcome screen from here. If you are
                    creating a new event, and wish that the event will have a
                    splash or welcome screen then please enable it using Yes.
                    You will need to upload new images for each of the sizes
                    mentioned. The Screen (9:16) is a universal size you will
                    provide an image in hi-resolution and we will resize it for
                    different phone sized as applicable.
                  </p>
                </div>
                <div class="vx-col md:w-3/12 w-full mt-5">
                  <label></label>
                  <vs-radio
                    class="ml-3"
                    v-model="BrandingJson['splashScreenImages']['Type']"
                    vs-value="Splash"
                    >Splash</vs-radio
                  >
                  <vs-radio
                    class="ml-3"
                    v-model="BrandingJson['splashScreenImages']['Type']"
                    vs-value="Welcome"
                    >Welcome</vs-radio
                  >
                </div>
                <div class="vx-col md:w-3/12 w-full mt-5">
                  <div class="flex justify-start items-center">
                    <label>Publish</label>
                    <vs-switch
                      v-model="
                        BrandingJson['splashScreenImages']['IsPublished']
                      "
                      class="ml-2"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-3/12 w-full mt-5">
                  <div class="flex justify-start items-center">
                    <label>Frequency Once</label>
                    <vs-switch
                      v-model="BrandingJson['splashScreenImages']['IsOnce']"
                      class="ml-2"
                    />
                  </div>
                </div>
                <div
                  class="vx-col md:w-3/12 w-full mt-5"
                  v-if="BrandingJson['splashScreenImages']['Type'] == 'Splash'"
                >
                  <div class="flex justify-start items-center">
                    <label class="mr-2">Duration</label>
                    <vs-input-number
                      class="inputx"
                      min="1"
                      v-model="BrandingJson['splashScreenImages']['duration']"
                    />
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['1125x2436']"
                        :src="BrandingJson['splashScreenImages']['1125x2436']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1125x2436',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1125x2436',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1125x2436 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['1440x2560']"
                        :src="BrandingJson['splashScreenImages']['1440x2560']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1440x2560',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1440x2560',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1440x2560 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big2-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['2048x2732']"
                        :src="BrandingJson['splashScreenImages']['2048x2732']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '2048x2732',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '2048x2732',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 2048x2732 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['1080x1920']"
                        :src="BrandingJson['splashScreenImages']['1080x1920']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1080x1920',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1080x1920',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1080x1920 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['1242x2688']"
                        :src="BrandingJson['splashScreenImages']['1242x2688']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '1242x2688',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '1242x2688',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 1242x2688 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash big-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['640x960']"
                        :src="BrandingJson['splashScreenImages']['640x960']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '640x960',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area image-upload-section-branging">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '640x960',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 640x960 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-col md:w-1/1 w-full mt-5">
                  <div class="event-icon-upload splash-screen-wrapper">
                    <div class="single-splash">
                      <img
                        v-if="BrandingJson['splashScreenImages']['2732x2048']"
                        :src="BrandingJson['splashScreenImages']['2732x2048']"
                      />
                      <span class="img-delete-butn">
                        <button
                          @click="
                            deleteBrandingJson(
                              $event,
                              '2732x2048',
                              'splashScreenImages'
                            )
                          "
                        >
                          <img src="../../assets/images/btn-del.png" />
                        </button>
                      </span>
                    </div>
                    <div class="choose-file-area">
                      <input
                        type="file"
                        @change="
                          uploadBrandingJson(
                            $event,
                            '2732x2048',
                            'splashScreenImages'
                          )
                        "
                        accept="image/*"
                      />
                      <div class="image-specification">
                        <p>
                          <strong>Image Specification</strong>
                        </p>
                        <p>
                          Dimension: (Width x Height) 2732x2048 pixels;
                          Format:JPG/PNG 72DPI
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Disclaimer" @click="showSubmitButton = true">
            <div class="tab-text">
              <div class="vx-row my-5">
                <div class="vx-col md:w-6/12 w-full mt-5">
                  <label>Acceptance Label</label>
                  <vs-input
                    class="inputx w-full"
                    v-model="BrandingJson['Disclaimer']['AcceptanceLabel']"
                  />
                </div>
                <div class="vx-col md:w-3/12 w-full mt-5">
                  <label>Publish</label>
                  <vs-switch
                    v-model="BrandingJson['Disclaimer']['IsPublished']"
                  />
                </div>
                <div class="vx-col md:w-3/12 w-full mt-5">
                  <label>Frequency Once</label>
                  <vs-switch v-model="BrandingJson['Disclaimer']['IsOnce']" />
                </div>
                <div class="vx-col md:w-6/12 w-full mt-5">
                  <label>Disclaimer Title</label>
                  <vs-input
                    class="inputx w-full"
                    v-model="BrandingJson['Disclaimer']['title']"
                  />
                </div>
                <div class="vx-col md:w-12/12 w-full mt-5">
                  <label>Disclaimer Text</label>
                  <ckeditor
                    class="desc-event"
                    v-model="BrandingJson['Disclaimer']['DisclaimerText']"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
      <div
        class="vx-col w-full mt-5 flex flex-wrap items-center justify-between"
        v-if="showSubmitButton"
      >
        <div>
          <vs-button
            class="mb-2"
            type="border"
            color="warning"
            @click="getClientsDefaultBrandingJson()"
            >Set Client Branding</vs-button
          >
          <vs-button
            v-if="currentTab != 2"
            class="mb-2 ml-3"
            type="border"
            @click="resetBranding()"
            >Reset</vs-button
          >
        </div>
        <!-- <vs-button class="mb-2 ml-3" type="border" @click="setBarndingAsDefault()">Set Default</vs-button> -->
        <vs-button class="mb-2 ml-10" @click="formSubmittedt4()"
          >Save</vs-button
        >
      </div>
    </vx-card>
  </div>
</template>

<script>
import CKEditor from "ckeditor4-vue";
import vSelect from "vue-select";
import moduleEventManagement from "@/store/event-management/moduleEventManagement.js";
import modulesvirtuallobbyManagementAdd from "@/store/virtuallobby-management/moduleVirtuallobbyManagement.js";
import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
import EventBanners from "./EventBanners.vue";
import ls from "@/common/localStorage";
import CKconfig from "@/assets/ckeditor-config.ts";
import con from "@/firebase/firebaseInit.ts";
import brandingAppSvgList from "@/assets/Brandingsvg.ts";
var cn = ls.getSessionEventCollectionName();
let Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id");
var Session_UserName = ls.getSessionValueByKey("Name");
var Event_Name = ls.getSessionValueByKey("Session_Event_FullName");
const virtuallobbyRef = con.eventDB.collection(cn).doc("VirtualLobby");
let Session_Event_Id = ls.getSessionValueByKey("Session_Event_Id");
var vm;

export default {
  data() {
    return {
      desktopBackground: null,
      fontBarColor: null,
      topBarColor: null,
      desktopBanner: null,
      viewMobile: "Desktop",
      tempBrandingJson: {},
      currentTab: 0,
      appBackgroundImage: "",
      defaultSvgs: brandingAppSvgList,
      allExhibitors: [],
      allAttendees: [],
      ShowAppNotification: true,
      SelectedBottomMenu: [],
      SelectedHamburgerMenu: [],
      SelectedLobbyMenu: [],
      SelectedWebTopMenu: [],
      SelectedWebLeftMenu: [],
      virtuallobby_data: null,
      loggedInUserName: Session_UserName,
      currentEventName: Event_Name,
      headerColorsHexCode: {
        topBar: "#000000",
        headerBar: "#000000",
        fontBar: "#ffffff",
        sideNavigationAndIconColor: "#64656E",
        activeButtonColor: "#000000",
        inactiveButtonColor: "#ffffff",
      },
      headerColorsHexCodeCustom: {
        cardBackground: "#ffffff",
        iconBackground: "#35393d",
        fontColorHeader: "#000000",
        fontColorSubHeader: "#919497",
        navigationBackgroundColor: "#ffffff",
        tabSelectionColor: "#000000",
        activeButtonColor: "#000",
        inactiveButtonColor: "#000",
      },
      BrandingJson: {
        EventInfo: {
          BodyTextColor: null,
          BackgroundColor: null,
          UseBackgroundImage: true,
          BackgroundImage: null,
          EventLogo: null,
          EventBanner: null,
          EventBannerMobile: null,
          DefaultGallerySelected: false,
          DefaultGalleryImage: {
            Name: "Wild black Background",
            Folder: "Set29",
            ThumbImg:
              "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet29%2Fthumb.png?alt=media",
          },
        },
        eventBGImage: { "2048x2732": "", "2732x2048": "" },
        banner: {
          TargetLink: "NoLink",
          ExternalLink: "",
          InternalLink: "",
          "640x88": "",
          "750x103": "",
          "1125x156": "",
          "1242x171": "",
          "1440x176": "",
          "2732x88": "",
          "2048x88": "",
        },
        eventBanners: [],
        eventBannersDuration: 1,
        splashScreenImages: {
          IsOnce: true,
          Type: "Splash",
          IsPublished: true,
          duration: 1,
          "1125x2436": "",
          "1440x2560": "",
          "2048x2732": "",
          "2732x2048": "",
        },
        Disclaimer: {
          title: "",
          IsOnce: true,
          IsPublished: true,
          AcceptanceLabel: "",
          DisclaimerText: "",
        },
        headerColorsHexCode: {
          topBar: "#FFFFFF",
          headerBar: "#FFFFFF",
          fontBar: "#000000",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#000",
          inactiveButtonColor: "#000",
        },
        appColorHexCodeType: "headerColorsHexCodeLight",
        headerColorsHexCodeLight: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
          activeButtonColor: "#000",
          inactiveButtonColor: "#000",
        },
        headerColorsHexCodeDark: {
          cardBackground: "#15191c",
          iconBackground: "#35393d",
          fontColorHeader: "#ffffff",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#272d30",
          tabSelectionColor: "#ffffff",
          activeButtonColor: "#000",
          inactiveButtonColor: "#000",
        },
        headerColorsHexCodeCustom: {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        },
      },
      GalleryImages: [
        {
          Name: "Grey Wave",
          Folder: "Set20",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet20%2Fthumb.png?alt=media",
        },
        {
          Name: "Mauve Wave",
          Folder: "Set21",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet21%2Fthumb.png?alt=media",
        },
        {
          Name: "Blue Wave",
          Folder: "Set22",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet22%2Fthumb.png?alt=media",
        },
        {
          Name: "Pink Wave",
          Folder: "Set23",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet23%2Fthumb.png?alt=media",
        },
        {
          Name: "Wind Background",
          Folder: "Set24",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet24%2Fthumb.png?alt=media",
        },
        {
          Name: "Glow Green Background",
          Folder: "Set25",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet25%2Fthumb.png?alt=media",
        },
        {
          Name: "Lights Background",
          Folder: "Set26",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet26%2Fthumb.png?alt=media",
        },
        {
          Name: "Blooming Background",
          Folder: "Set27",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet27%2Fthumb.png?alt=media",
        },
        {
          Name: "Grass Background",
          Folder: "Set28",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet28%2Fthumb.png?alt=media",
        },
        {
          Name: "Wild black Background",
          Folder: "Set29",
          ThumbImg:
            "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet29%2Fthumb.png?alt=media",
        },
      ],
      landingURLOptions: [
        "/lobby",
        "/sessions",
        "/livestage",
        "/stageview",
        "/attendee",
        "/exhibitorshall",
        "/mymeetings",
        "/myprofile",
      ],
      compkey: 0,
      editorConfig: CKconfig.editorConfig,
      showSubmitButton: true,
    };
  },
  methods: {
    mouseenter: function () {
      document.getElementById("attendeeDetailsBranding").style.boxShadow =
        "0 0 0 5px #eb775d";
      document.getElementById("attendeeDetailsBranding").style.transition =
        "all 0.4s";
    },
    mouseleave: function () {
      document.getElementById("attendeeDetailsBranding").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("attendeeDetailsBranding").style.transition =
        "all 0.4s";
    },

    colorchangeenter: function () {
      // document.getElementsByClassName("sim-attendee-image attendee-branding-image-color").style.boxShadow = "0 0 0 5px #eb775d";
      // document.getElementsByClassName("sim-attendee-image attendee-branding-image-color").style.transition = "all 0.4s";
      document.getElementById("changeBackgroundColor").style.boxShadow =
        "0 0 0 5px #eb775d";
      document.getElementById("changeBackgroundColor").style.transition =
        "all 0.4s";
      document.getElementById("changeBackgroundColor2").style.boxShadow =
        "0 0 0 5px #eb775d";
      document.getElementById("changeBackgroundColor2").style.transition =
        "all 0.4s";
      document.getElementById("searchBackgroundChange").style.boxShadow =
        "0 0 0 3px #eb775d";
      document.getElementById("searchBackgroundChange").style.transition =
        "all 0.4s";
    },
    colorchangeremove: function () {
      // document.getElementsByClassName("sim-attendee-image attendee-branding-image-color").style.boxShadow = "0 0 0 5px #eb775d";
      // document.getElementsByClassName("sim-attendee-image attendee-branding-image-color").style.transition = "all 0.4s";
      document.getElementById("changeBackgroundColor").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("changeBackgroundColor").style.transition =
        "all 0.4s";
      document.getElementById("changeBackgroundColor2").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("changeBackgroundColor2").style.transition =
        "all 0.4s";
      document.getElementById("searchBackgroundChange").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("searchBackgroundChange").style.transition =
        "all 0.4s";
    },

    changebtnback: function () {
      document.getElementById("joinRoundTableColorChanger").style.boxShadow =
        "0 0 0 2px #eb775d";
      document.getElementById("joinRoundTableColorChanger").style.transition =
        "all 0.4s";
      document.getElementById(
        "requestMeetingButtonColorChange"
      ).style.boxShadow = "0 0 0 4px #eb775d";
      document.getElementById(
        "requestMeetingButtonColorChange"
      ).style.transition = "all 0.4s";
    },
    changebtndefault: function () {
      document.getElementById("joinRoundTableColorChanger").style.boxShadow =
        "0 0 0 0 #eb775d";
      document.getElementById("joinRoundTableColorChanger").style.transition =
        "all 0.4s";
      document.getElementById(
        "requestMeetingButtonColorChange"
      ).style.boxShadow = "0 0 0 0px #eb775d";
      document.getElementById(
        "requestMeetingButtonColorChange"
      ).style.transition = "all 0.4s";
    },

    lobbycardcolorchanger: function () {
      document.getElementById("simCardColorChange").style.boxShadow =
        "0 0 0 5px #eb775d";
      document.getElementById("simCardColorChange").style.transition =
        "all 0.4s";
    },
    lobbycardcolorcdefault: function () {
      document.getElementById("simCardColorChange").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("simCardColorChange").style.transition =
        "all 0.4s";
    },

    navColorChange: function () {
      document.getElementById("changeNavColor").style.boxShadow =
        "0 0 0 5px #eb775d";
      document.getElementById("changeNavColor").style.transition = "all 0.4s";
    },
    navColorDefault: function () {
      document.getElementById("changeNavColor").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("changeNavColor").style.transition = "all 0.4s";
    },

    headercolorchanger: function () {
      document.getElementById("changeHeaderColor").style.textShadow =
        "0px 0px 8px #f00, 0 0 05px green, 0px 0 4px yellow";
      document.getElementById("changeHeaderColor").style.transition =
        "all 0.4s";
      document.getElementById("colorChangerHeader2").style.textShadow =
        "0px 0px 8px #f00, 0 0 05px green, 0px 0 4px yellow";
      document.getElementById("colorChangerHeader2").style.transition =
        "all 0.4s";
    },
    headercolorremove: function () {
      document.getElementById("changeHeaderColor").style.textShadow =
        "0px 0px 0px #f00, 0 0 00px green, 0px 0 0px yellow";
      document.getElementById("changeHeaderColor").style.transition =
        "all 0.4s";
      document.getElementById("colorChangerHeader2").style.textShadow =
        "0px 0px 0px #f00, 0 0 00px green, 0px 0 0px yellow";
      document.getElementById("colorChangerHeader2").style.transition =
        "all 0.4s";
    },

    exchangeBtnFontColor: function () {
      document.getElementById("exchangebuttonchange").style.boxShadow =
        "0 0 0 3px #eb775d";
      document.getElementById("exchangebuttonchange").style.transition =
        "all 0.4s";
    },
    exchangeBtnFontDefault: function () {
      document.getElementById("exchangebuttonchange").style.boxShadow =
        "0 0 0 0px #eb775d";
      document.getElementById("exchangebuttonchange").style.transition =
        "all 0.4s";
    },

    resetBranding() {
      console.log("tempBrandingJson====", vm.tempBrandingJson);
      console.log("BrandingJson====", vm.BrandingJson);

      if (vm.currentTab == 4) {
        vm.BrandingJson.Disclaimer = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.Disclaimer)
        );
      }
      if (vm.currentTab == 1) {
        vm.BrandingJson["EventInfo"]["BackgroundColor"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.BackgroundColor)
        );

        vm.BrandingJson["EventInfo"]["BodyTextColor"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.BodyTextColor)
        );
        vm.BrandingJson["EventInfo"]["UseBackgroundImage"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.UseBackgroundImage)
        );

        vm.BrandingJson["EventInfo"]["DefaultGallerySelected"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.DefaultGallerySelected)
        );

        vm.BrandingJson["EventInfo"]["DefaultGalleryImage"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.DefaultGalleryImage)
        );

        vm.BrandingJson.eventBGImage["2048x2732"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["2048x2732"])
        );
        vm.BrandingJson.eventBGImage["2732x2048"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["2732x2048"])
        );
        vm.BrandingJson.eventBGImage["1440x2560"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["1440x2560"])
        );
        vm.BrandingJson.eventBGImage["1125x2436"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["1125x2436"])
        );
        vm.BrandingJson.eventBGImage["1080x1920"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["1080x1920"])
        );
        vm.BrandingJson.eventBGImage["1242x2688"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["1242x2688"])
        );
        vm.BrandingJson.eventBGImage["640x960"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.eventBGImage["640x960"])
        );
        vm.appBackgroundImage = vm.BrandingJson.eventBGImage["1440x2560"];
        vm.BrandingJson.EventInfo.BackgroundImage =
          vm.BrandingJson.eventBGImage["2732x2048"];
        vm.BrandingJson["EventInfo"]["BodyTextColor"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.EventInfo.BodyTextColor)
        );
      }
      if (vm.currentTab == 3) {
        vm.BrandingJson["splashScreenImages"]["duration"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages.duration)
        );
        vm.BrandingJson["splashScreenImages"]["Type"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages.Type)
        );
        vm.BrandingJson["splashScreenImages"]["IsPublished"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages.IsPublished)
        );
        vm.BrandingJson["splashScreenImages"]["IsOnce"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages.IsOnce)
        );
        vm.BrandingJson["splashScreenImages"]["1125x2436"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["1125x2436"])
        );
        vm.BrandingJson["splashScreenImages"]["1440x2560"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["1440x2560"])
        );
        vm.BrandingJson["splashScreenImages"]["2048x2732"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["2048x2732"])
        );
        vm.BrandingJson["splashScreenImages"]["1080x1920"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["1080x1920"])
        );
        vm.BrandingJson["splashScreenImages"]["1242x2688"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["1242x2688"])
        );
        vm.BrandingJson["splashScreenImages"]["640x960"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["640x960"])
        );
        vm.BrandingJson["splashScreenImages"]["2732x2048"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.splashScreenImages["2732x2048"])
        );
      }
      if (vm.currentTab == 0) {
        vm.BrandingJson.appColorHexCodeType = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.appColorHexCodeType)
        );
        vm.BrandingJson["headerColorsHexCodeCustom"][
          "navigationBackgroundColor"
        ] = JSON.parse(
          JSON.stringify(
            vm.tempBrandingJson.headerColorsHexCodeCustom
              .navigationBackgroundColor
          )
        );
        vm.BrandingJson["headerColorsHexCode"]["topBar"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.headerColorsHexCode.topBar)
        );
        vm.BrandingJson["headerColorsHexCode"]["sideNavigationAndIconColor"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCode.sideNavigationAndIconColor
            )
          );
        vm.BrandingJson["headerColorsHexCodeCustom"]["fontColorHeader"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCodeCustom.fontColorHeader
            )
          );
        vm.BrandingJson["headerColorsHexCodeCustom"]["fontColorSubHeader"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCodeCustom.fontColorSubHeader
            )
          );
        vm.BrandingJson["headerColorsHexCodeCustom"]["cardBackground"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCodeCustom.cardBackground
            )
          );
        vm.BrandingJson["headerColorsHexCodeCustom"]["tabSelectionColor"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCodeCustom.tabSelectionColor
            )
          );
        vm.BrandingJson["headerColorsHexCode"]["headerBar"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.headerColorsHexCode.headerBar)
        );
        vm.BrandingJson["headerColorsHexCodeCustom"]["iconBackground"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCodeCustom.iconBackground
            )
          );
        vm.BrandingJson["headerColorsHexCode"]["activeButtonColor"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCode.activeButtonColor
            )
          );
        vm.BrandingJson["headerColorsHexCode"]["inactiveButtonColor"] =
          JSON.parse(
            JSON.stringify(
              vm.tempBrandingJson.headerColorsHexCode.inactiveButtonColor
            )
          );
        vm.BrandingJson["headerColorsHexCode"]["fontBar"] = JSON.parse(
          JSON.stringify(vm.tempBrandingJson.headerColorsHexCode.fontBar)
        );
        this.fetch_virtuallobby_data(virtuallobbyRef);
        this.fetchEventAppMenu();
        this.fetchAllAttendees();
        this.fetchAllExhibitors();
        this.fetchEventWebMenu();
      }
      this.$vs.notify({
        color: "success",
        position: "top-center",
        title: "Branding",
        text: "Branding reset to previous saved version",
      });
      //this.fetchBrandingJson();
    },
    fetchAllExhibitors() {
      this.$store
        .dispatch("exhibitorManagement/fetchExhibitors")
        .then((res) => {
          this.allExhibitors = res;
        });
    },
    fetchAllAttendees() {
      this.$store.dispatch("attendeeManagement/fetchAttendees").then((res) => {
        console.log("res attendee------", res);
        res.map((user) => {
          if (user.FirstName) {
            this.allAttendees.push(user);
          }
        });
        this.allAttendees.sort((a, b) =>
          a.FirstName.localeCompare(b.FirstName)
        );
      });
    },
    fetchEventAppMenu() {
      this.$store.dispatch("eventManagement/fetchEventAppMenu").then((res) => {
        console.log("res=2===", res);

        this.ShowAppNotification =
          res.ShowAppNotification == undefined ? true : res.ShowAppNotification;
        this.SelectedBottomMenu = res.SelectedBottomMenu
          ? res.SelectedBottomMenu
          : [];
        this.SelectedHamburgerMenu = res.SelectedHamburgerMenu
          ? res.SelectedHamburgerMenu
          : [];
        this.SelectedLobbyMenu = res.SelectedLobbyMenu
          ? res.SelectedLobbyMenu
          : [];
      });
    },
    fetchEventWebMenu() {
      this.$store
        .dispatch("eventManagement/fetchEventMenu", Session_Event_Id)
        .then((res) => {
          console.log("web menu ====", res);

          this.SelectedWebTopMenu = res.SelectedMenu;
          this.SelectedWebLeftMenu = res.SelectedLeftMenu;
        })
        .catch((err) => {});
    },
    fetch_virtuallobby_data() {
      this.$store
        .dispatch("virtuallobbyManagement/fetchVirtuallobby", virtuallobbyRef)
        .then((res) => {
          this.virtuallobby_data = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },


    setheaderColorsHexCode(color) {
      if (vm.BrandingJson.webColorHexCodeType == "webheaderColorsHexCodeLight") {
        vm.topBarColor = "#FFFFFF";
        vm.fontBarColor = "#000000";
         vm.BrandingJson.webheaderColorsHexCode = {
          topBar: "#FFFFFF",
          headerBar: "#FFFFFF",
          fontBar: "#000000",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#ffffff",
          inactiveButtonColor: "#000000",
        };
      }
      if (vm.BrandingJson.webColorHexCodeType == "webheaderColorsHexCodeDark") {
        vm.topBarColor = "#000000";
        vm.fontBarColor = "#FFFFFF";
         vm.BrandingJson.webheaderColorsHexCode = {
          topBar: "#000000",
          headerBar: "#FFFFFF",
          fontBar: "#FFFFFF",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#ffffff",
          inactiveButtonColor: "#000000",
        };

        
      }
      if (color == "Light") {
        vm.BrandingJson.headerColorsHexCode = {
          topBar: "#FFFFFF",
          headerBar: "#FFFFFF",
          fontBar: "#000000",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#ffffff",
          inactiveButtonColor: "#000000",
        };
        vm.BrandingJson.headerColorsHexCodeCustom = {
          cardBackground: "#ffffff",
          iconBackground: "#35393d",
          fontColorHeader: "#000000",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#ffffff",
          tabSelectionColor: "#000000",
        };
      } else if (color == "Dark") {
        vm.BrandingJson.headerColorsHexCode = {
          topBar: "#000000",
          headerBar: "#000000",
          fontBar: "#ffffff",
          sideNavigationAndIconColor: "#64656E",
          activeButtonColor: "#000000",
          inactiveButtonColor: "#ffffff",
        };
        vm.BrandingJson.headerColorsHexCodeCustom = {
          cardBackground: "#000000",
          iconBackground: "#35393d",
          fontColorHeader: "#ffffff",
          fontColorSubHeader: "#919497",
          navigationBackgroundColor: "#000000",
          tabSelectionColor: "#ffffff",
          activeButtonColor: "#0061ff",
          inactiveButtonColor: "#ffffff",
        };
      } else if (color == "Custom") {
        vm.BrandingJson.headerColorsHexCodeCustom =
          vm.headerColorsHexCodeCustom;
        vm.BrandingJson.headerColorsHexCode = vm.headerColorsHexCode;
      }
    },
    deleteBrandingJson(input, filename, filesrc) {
      if (confirm("Image will be deleted!")) {
        let clientId = this.$route.params.clientId;
        this.$vs.loading();
        this.$store
          .dispatch("eventManagement/deleteBrandingJson", {
            filename: filename,
            brandingJson: this.BrandingJson,
            updateField: filesrc,
          })
          .then((res) => {
            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Branding",
              text: "Deleted with image size: " + filename,
            });
            this.BrandingJson[filesrc][filename] = "";
            if (
              filesrc.toLowerCase() === "eventbgimage" &&
              filename.toLowerCase() === "2732x2048"
            ) {
              this.BrandingJson.EventInfo.BackgroundImage = "";
            }
            if (
              filesrc.toLowerCase() === "banner" &&
              filename.toLowerCase() === "2048x88"
            ) {
              this.BrandingJson.EventInfo.EventBanner = "";
            }
            if (
              filesrc.toLowerCase() === "banner" &&
              filename.toLowerCase() === "750x103"
            ) {
              this.BrandingJson.EventInfo.EventBannerMobile = "";
            }
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      }
    },
    uploadBrandingJson(input, filename, filesrc) {
      //alert("uploadBrandingJson:" + filename);
      //console.log(filename + filesrc)
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        input.target.value = "";
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }
        let dimension = [];
        if (filesrc.toLowerCase() === "hostinfo") {
          dimension = [960, 192];
        } else {
          dimension = filename.split("x");
        }
        //let dimension = filename.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width == dimension[0] && this.height == dimension[1]) {
            vm.uploadFile(file, filename, filesrc);
          } else {
            alert("File dimension does not match " + filename);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;
      }
    },
    uploadFile(file, filename, filesrc) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.BrandingJson[filesrc][filename] = e.target.result;
      };
      reader.readAsDataURL(file);
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/uploadBrandingJson", {
          file: file,
          filename: filename,
          brandingJson: this.BrandingJson,
          updateField: filesrc,
        })
        .then((res) => {
          //alert(res.message)
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "Updated with image size: " + filename,
          });
          this.$vs.loading.close();
          if (
            filesrc.toLowerCase() === "eventbgimage" &&
            filename.toLowerCase() === "2732x2048"
          ) {
            this.BrandingJson.EventInfo.BackgroundImage = res;
          }
          if (
            filesrc.toLowerCase() === "banner" &&
            filename.toLowerCase() === "2048x88"
          ) {
            this.BrandingJson.EventInfo.EventBanner = res;
          }
          if (
            filesrc.toLowerCase() === "banner" &&
            filename.toLowerCase() === "750x103"
          ) {
            this.BrandingJson.EventInfo.EventBannerMobile = res;
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    formSubmittedt4() {
      //console.log(vm.BrandingJson.EventInfo.DefaultGalleryImage)
      //return false;
      this.$vs.loading();
      if (
        this.BrandingJson.EventInfo.DefaultGalleryImage &&
        this.BrandingJson.EventInfo.DefaultGallerySelected &&
        this.BrandingJson.EventInfo.UseBackgroundImage
      ) {
        this.BrandingJson.eventBGImage = {
          "2048x2732": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F2048_2732.png?alt=media`,
          "2732x2048": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F2732_2048.png?alt=media`,
          "1440x2560": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F1440_2560.png?alt=media`,
          "1125x2436": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F1125_2436.png?alt=media`,
          "1080x1920": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F1080_1920.png?alt=media`,
          "1242x2688": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F1242_2208.png?alt=media`,
          "640x960": `https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2F${this.BrandingJson.EventInfo.DefaultGalleryImage.Folder}%2F640_960.png?alt=media`,
        };
        this.BrandingJson.EventInfo.BackgroundImage =
          this.BrandingJson.eventBGImage["2732x2048"];
      } else {
        this.BrandingJson.EventInfo.DefaultGalleryImage = null;
      }

      let banner = this.BrandingJson.banner ? this.BrandingJson.banner : null;
      if (this.BrandingJson.eventBanners.length) {
        banner = this.BrandingJson.eventBanners[0];
      }
      if (banner && banner["2048x88"]) {
        this.BrandingJson.EventInfo.EventBanner = banner["2048x88"];
      }
      if (banner && banner["750x103"]) {
        this.BrandingJson.EventInfo.EventBannerMobile = banner["750x103"];
      }
      if (banner) {
        this.BrandingJson.banner = banner;
      }
      this.BrandingJson.headerColorsHexCodeLight.activeButtonColor = "#0061ff";
      this.BrandingJson.headerColorsHexCodeLight.inactiveButtonColor = "#ffffff";
      this.BrandingJson.headerColorsHexCodeDark.activeButtonColor = "#0061ff";
      this.BrandingJson.headerColorsHexCodeDark.inactiveButtonColor = "#ffffff";

      if(this.BrandingJson.appColorHexCodeType == 'headerColorsHexCodeCustom'){
        this.BrandingJson.headerColorsHexCodeCustom.activeButtonColor =  this.BrandingJson.headerColorsHexCode.activeButtonColor;
         this.BrandingJson.headerColorsHexCodeCustom.inactiveButtonColor =  this.BrandingJson.headerColorsHexCode.inactiveButtonColor;
      }

      console.log("branding save >>>>>>>>>>",JSON.stringify(vm.BrandingJson));


      this.$store
        .dispatch("eventManagement/uploadBrandingJsonColor", {
          brandingJson: this.BrandingJson,
        })
        .then((res) => {
          vm.tempBrandingJson = JSON.parse(JSON.stringify(vm.BrandingJson));
          this.updateEventField();
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "JSON updated",
          });
          this.$vs.loading.close();
          if (res.status == 200) {
            //this.$router.push('/event/list');
          }
        })
        .catch((err) => {
          //console.error(err)
          this.$vs.loading.close();
        });
    },
    updateEventField() {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/updateEventField", {
          data: {
            BodyTextColor: vm.BrandingJson.EventInfo.BodyTextColor,
            BackgroundColor: vm.BrandingJson.EventInfo.BackgroundColor,
            UseBackgroundImage: vm.BrandingJson.EventInfo.UseBackgroundImage,
            BackgroundImage: vm.BrandingJson.EventInfo.BackgroundImage,
            EventBanner: vm.BrandingJson.EventInfo.EventBanner,
            EventBannerMobile: vm.BrandingJson.EventInfo.EventBannerMobile
              ? vm.BrandingJson.EventInfo.EventBannerMobile
              : "",
            DefaultGallerySelected:
              vm.BrandingJson.EventInfo.DefaultGallerySelected,
            DefaultGalleryImage: vm.BrandingJson.EventInfo.DefaultGalleryImage
              ? vm.BrandingJson.EventInfo.DefaultGalleryImage
              : null,
          },
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Event",
            text: res.message,
          });
          this.$vs.loading.close();
        });
    },
    setBarndingAsDefault() {
      this.$vs.loading();
      let brandingJson = { ...this.BrandingJson };
      delete brandingJson.EventInfo;
      this.$store
        .dispatch("eventManagement/setBarndingAsDefault", brandingJson)
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Branding",
            text: "JSON set as default",
          });
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
        });
    },
    getClientsDefaultBrandingJson() {
      if (
        confirm(
          "All saved assets and color theming will be deleted. Do you want to continue?"
        )
      ) {
        this.$vs.loading();
        this.$store
          .dispatch("eventManagement/getClientsDefaultBrandingJson")
          .then((res) => {
            this.$vs.loading.close();
            if (res) {
              for (let key of Object.keys(res)) {
                this.BrandingJson[key] = res[key];
              }
            } else {
              this.$vs.notify({
                color: "warning",
                position: "top-center",
                text: "Default Branding Not Set!",
              });
            }
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      }
    },
    fetchBrandingJson() {
      this.$vs.loading();
      this.$store
        .dispatch("eventManagement/fetchBrandingJson")
        .then((res) => {
          this.$vs.loading.close();
          if (res) {
            let brandingJson = res;

            console.log("===branding res==", brandingJson);

            this.appBackgroundImage = brandingJson.eventBGImage["1440x2560"];
            let info = {
              Session_Event_Theme: res.appColorHexCodeType,
            };
            ls.setSessionUserInfo(info);
            if (brandingJson.EventInfo) {
              vm.desktopBanner = brandingJson.EventInfo.EventBanner;
              if (
                brandingJson.webColorHexCodeType &&
                brandingJson.webColorHexCodeType == "headerColorsHexCodeLight"
              ) {
                vm.topBarColor = "#FFFFFF";
                vm.fontBarColor = "#000000";
              } else {
                vm.topBarColor = "#000000";
                vm.fontBarColor = "#FFFFFF";
              }

              vm.desktopBackground = brandingJson.eventBGImage["2732x2048"];

              brandingJson.EventInfo.BodyTextColor = res.EventInfo.BodyTextColor
                ? res.EventInfo.BodyTextColor
                : "#000";
              brandingJson.EventInfo.BackgroundColor = res.EventInfo
                .BackgroundColor
                ? res.EventInfo.BackgroundColor
                : "#FFF";
              brandingJson.EventInfo.UseBackgroundImage =
                res.EventInfo.UseBackgroundImage == undefined
                  ? true
                  : res.EventInfo.UseBackgroundImage;
              brandingJson.EventInfo.BackgroundImage = res.EventInfo
                .BackgroundImage
                ? res.EventInfo.BackgroundImage
                : null;
              brandingJson.EventInfo.EventBanner = res.EventInfo.EventBanner
                ? res.EventInfo.EventBanner
                : null;
              brandingJson.EventInfo.EventBannerMobile = res.EventInfo
                .EventBannerMobile
                ? res.EventInfo.EventBannerMobile
                : null;
              if (!res.EventInfo.EventBannerMobile) {
                brandingJson.EventInfo.EventBannerMobile = res.banner["750x103"]
                  ? res.banner["750x103"]
                  : null;
              }
              brandingJson.EventInfo["DefaultGallerySelected"] =
                res.EventInfo.DefaultGallerySelected == undefined
                  ? false
                  : res.EventInfo.DefaultGallerySelected;
              if (!res.EventInfo.DefaultGalleryImage) {
                brandingJson.EventInfo["DefaultGalleryImage"] = {
                  Name: "Wild black Background",
                  Folder: "Set29",
                  ThumbImg:
                    "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet29%2Fthumb.png?alt=media",
                };
              }
            } else {
              brandingJson.EventInfo = {
                BodyTextColor: res.EventInfo.BodyTextColor
                  ? res.EventInfo.BodyTextColor
                  : "#000",
                BackgroundColor: res.EventInfo.BackgroundColor
                  ? res.EventInfo.BackgroundColor
                  : "#FFF",
                UseBackgroundImage:
                  res.EventInfo.UseBackgroundImage == undefined
                    ? false
                    : res.EventInfo.UseBackgroundImage,
                BackgroundImage: res.EventInfo.BackgroundImage
                  ? res.EventInfo.BackgroundImage
                  : null,
                DefaultGallerySelected:
                  res.EventInfo.DefaultGallerySelected == undefined
                    ? false
                    : res.EventInfo.DefaultGallerySelected,
                DefaultGalleryImage: {
                  Name: "Wild black Background",
                  Folder: "Set29",
                  ThumbImg:
                    "https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2FDefaults%2Fimage%2FBG%2FGalleryDefault%2FSet29%2Fthumb.png?alt=media",
                },
              };
            }

            brandingJson.banner["TargetLink"] = res.banner["TargetLink"]
              ? res.banner["TargetLink"]
              : "NoLink";
            brandingJson.banner["ExternalLink"] = res.banner["ExternalLink"]
              ? res.banner["ExternalLink"]
              : "";
            brandingJson.banner["InternalLink"] = res.banner["InternalLink"]
              ? res.banner["InternalLink"]
              : "";
            brandingJson.eventBanners =
              res.eventBanners && res.eventBanners.length
                ? res.eventBanners
                : [];
            if (brandingJson.eventBanners.length == 0 && brandingJson.banner) {
              let defaultBanner = { ...brandingJson.banner };
              // defaultBanner.IsDefault = true;
              // defaultBanner.IsOnce = true;
              // defaultBanner.duration = 1;
              brandingJson.eventBanners.push(defaultBanner);
            }
            brandingJson.eventBannersDuration =
              res.eventBannersDuration == undefined
                ? 1
                : res.eventBannersDuration;

            if (res.headerColorsHexCodeLight) {
            } else {
              brandingJson.headerColorsHexCodeLight = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
                activeButtonColor:"#0061ff",
                inactiveButtonColor:"#ffffff",
              };
            }

            if (res.headerColorsHexCodeDark) {
            } else {

              brandingJson.headerColorsHexCodeDark = {
                cardBackground: "#15191c",
                iconBackground: "#35393d",
                fontColorHeader: "#ffffff",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#272d30",
                tabSelectionColor: "#ffffff",
                activeButtonColor:"#0061ff",
                inactiveButtonColor:"#ffffff",
              };
            }

            if (res.headerColorsHexCodeCustom) {
              vm.headerColorsHexCodeCustom = res.headerColorsHexCodeCustom;
              vm.headerColorsHexCode = res.headerColorsHexCode;
            } else {
              brandingJson.headerColorsHexCodeCustom = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
                activeButtonColor: "#000",
                inactiveButtonColor: "#000",
              };
            }
            if (res.appColorHexCodeType) {
            } else {
              brandingJson.appColorHexCodeType = "headerColorsHexCodeLight";
              brandingJson.webColorHexCodeType = "headerColorsHexCodeLight";
              brandingJson.headerColorsHexCodeLight = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
                activeButtonColor:"#0061ff",
                inactiveButtonColor:"#ffffff",
              };
              brandingJson.headerColorsHexCodeDark = {
                cardBackground: "#15191c",
                iconBackground: "#35393d",
                fontColorHeader: "#ffffff",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#272d30",
                tabSelectionColor: "#ffffff",
                activeButtonColor:"#0061ff",
                inactiveButtonColor:"#ffffff",
              };
              brandingJson.headerColorsHexCodeCustom = {
                cardBackground: "#ffffff",
                iconBackground: "#35393d",
                fontColorHeader: "#000000",
                fontColorSubHeader: "#919497",
                navigationBackgroundColor: "#ffffff",
                tabSelectionColor: "#000000",
              };
            }
            brandingJson.splashScreenImages = res.splashScreenImages
              ? res.splashScreenImages
              : {
                  IsOnce: true,
                  Type: "Splash",
                  IsPublished: true,
                  duration: 1,
                  "1125x2436": "",
                  "1440x2560": "",
                  "2048x2732": "",
                  "2732x2048": "",
                };
            brandingJson.Disclaimer = res.Disclaimer
              ? res.Disclaimer
              : {
                  title: "",
                  IsOnce: true,
                  AcceptanceLabel: "",
                  DisclaimerText: "",
                  IsPublished: true,
                };
            vm.BrandingJson = brandingJson;
            vm.tempBrandingJson = JSON.parse(JSON.stringify(vm.BrandingJson));
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.log(err);
        });
    },
    showHideSubmitButton(val) {
      this.showSubmitButton = val;
    },
  },
  components: {
    ckeditor: CKEditor.component,
    vSelect,
    EventBanners,
  },
  mounted() {
    vm = this;
    if (!moduleEventManagement.isRegistered) {
      this.$store.registerModule("eventManagement", moduleEventManagement);
      moduleEventManagement.isRegistered = true;
    }
    // Register virtual lobbyManagement Module
    if (!modulesvirtuallobbyManagementAdd.isRegistered) {
      this.$store.registerModule(
        "virtuallobbyManagement",
        modulesvirtuallobbyManagementAdd
      );
      modulesvirtuallobbyManagementAdd.isRegistered = true;
    }
    if (!moduleAttendeeManagement.isRegistered) {
      this.$store.registerModule(
        "attendeeManagement",
        moduleAttendeeManagement
      );
      moduleAttendeeManagement.isRegistered = true;
    }
    if (!moduleExhibitorManagement.isRegistered) {
      this.$store.registerModule(
        "exhibitorManagement",
        moduleExhibitorManagement
      );
      moduleExhibitorManagement.isRegistered = true;
    }
    this.fetchBrandingJson();
    this.fetch_virtuallobby_data(virtuallobbyRef);
    this.fetchEventAppMenu();
    this.fetchAllAttendees();
    this.fetchAllExhibitors();
    this.fetchEventWebMenu();
  },
};
</script>
